var Nt;
(function(e) {
  e.North = "north", e.South = "south", e.Centre = "centre", e.East = "east", e.West = "west", e.Smart = "smart";
})(Nt || (Nt = {}));
var me;
(function(e) {
  e.RESIZE = "resize", e.EXTRACT = "extract", e.SMARTCROP = "smartcrop", e.CONVERT = "convert", e.CROP = "crop";
})(me || (me = {}));
var zr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function kr(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      if (this instanceof n) {
        var a = [null];
        a.push.apply(a, arguments);
        var i = Function.bind.apply(t, a);
        return new i();
      }
      return t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var a = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, a.get ? a : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var hr = {}, Hr = (e) => encodeURIComponent(e).replace(/[!'()*]/g, (t) => `%${t.charCodeAt(0).toString(16).toUpperCase()}`), mr = "%[a-f0-9]{2}", Lt = new RegExp("(" + mr + ")|([^%]+?)", "gi"), _t = new RegExp("(" + mr + ")+", "gi");
function yt(e, t) {
  try {
    return [decodeURIComponent(e.join(""))];
  } catch {
  }
  if (e.length === 1)
    return e;
  t = t || 1;
  var r = e.slice(0, t), n = e.slice(t);
  return Array.prototype.concat.call([], yt(r), yt(n));
}
function qr(e) {
  try {
    return decodeURIComponent(e);
  } catch {
    for (var t = e.match(Lt) || [], r = 1; r < t.length; r++)
      e = yt(t, r).join(""), t = e.match(Lt) || [];
    return e;
  }
}
function Vr(e) {
  for (var t = {
    "%FE%FF": "��",
    "%FF%FE": "��"
  }, r = _t.exec(e); r; ) {
    try {
      t[r[0]] = decodeURIComponent(r[0]);
    } catch {
      var n = qr(r[0]);
      n !== r[0] && (t[r[0]] = n);
    }
    r = _t.exec(e);
  }
  t["%C2"] = "�";
  for (var a = Object.keys(t), i = 0; i < a.length; i++) {
    var o = a[i];
    e = e.replace(new RegExp(o, "g"), t[o]);
  }
  return e;
}
var Qr = function(e) {
  if (typeof e != "string")
    throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof e + "`");
  try {
    return e = e.replace(/\+/g, " "), decodeURIComponent(e);
  } catch {
    return Vr(e);
  }
}, Jr = (e, t) => {
  if (!(typeof e == "string" && typeof t == "string"))
    throw new TypeError("Expected the arguments to be of type `string`");
  if (t === "")
    return [e];
  const r = e.indexOf(t);
  return r === -1 ? [e] : [
    e.slice(0, r),
    e.slice(r + t.length)
  ];
}, Gr = function(e, t) {
  for (var r = {}, n = Object.keys(e), a = Array.isArray(t), i = 0; i < n.length; i++) {
    var o = n[i], s = e[o];
    (a ? t.indexOf(o) !== -1 : t(o, s, e)) && (r[o] = s);
  }
  return r;
};
(function(e) {
  const t = Hr, r = Qr, n = Jr, a = Gr, i = (u) => u == null, o = Symbol("encodeFragmentIdentifier");
  function s(u) {
    switch (u.arrayFormat) {
      case "index":
        return (l) => (h, y) => {
          const m = h.length;
          return y === void 0 || u.skipNull && y === null || u.skipEmptyString && y === "" ? h : y === null ? [...h, [d(l, u), "[", m, "]"].join("")] : [
            ...h,
            [d(l, u), "[", d(m, u), "]=", d(y, u)].join("")
          ];
        };
      case "bracket":
        return (l) => (h, y) => y === void 0 || u.skipNull && y === null || u.skipEmptyString && y === "" ? h : y === null ? [...h, [d(l, u), "[]"].join("")] : [...h, [d(l, u), "[]=", d(y, u)].join("")];
      case "colon-list-separator":
        return (l) => (h, y) => y === void 0 || u.skipNull && y === null || u.skipEmptyString && y === "" ? h : y === null ? [...h, [d(l, u), ":list="].join("")] : [...h, [d(l, u), ":list=", d(y, u)].join("")];
      case "comma":
      case "separator":
      case "bracket-separator": {
        const l = u.arrayFormat === "bracket-separator" ? "[]=" : "=";
        return (h) => (y, m) => m === void 0 || u.skipNull && m === null || u.skipEmptyString && m === "" ? y : (m = m === null ? "" : m, y.length === 0 ? [[d(h, u), l, d(m, u)].join("")] : [[y, d(m, u)].join(u.arrayFormatSeparator)]);
      }
      default:
        return (l) => (h, y) => y === void 0 || u.skipNull && y === null || u.skipEmptyString && y === "" ? h : y === null ? [...h, d(l, u)] : [...h, [d(l, u), "=", d(y, u)].join("")];
    }
  }
  function c(u) {
    let l;
    switch (u.arrayFormat) {
      case "index":
        return (h, y, m) => {
          if (l = /\[(\d*)\]$/.exec(h), h = h.replace(/\[\d*\]$/, ""), !l) {
            m[h] = y;
            return;
          }
          m[h] === void 0 && (m[h] = {}), m[h][l[1]] = y;
        };
      case "bracket":
        return (h, y, m) => {
          if (l = /(\[\])$/.exec(h), h = h.replace(/\[\]$/, ""), !l) {
            m[h] = y;
            return;
          }
          if (m[h] === void 0) {
            m[h] = [y];
            return;
          }
          m[h] = [].concat(m[h], y);
        };
      case "colon-list-separator":
        return (h, y, m) => {
          if (l = /(:list)$/.exec(h), h = h.replace(/:list$/, ""), !l) {
            m[h] = y;
            return;
          }
          if (m[h] === void 0) {
            m[h] = [y];
            return;
          }
          m[h] = [].concat(m[h], y);
        };
      case "comma":
      case "separator":
        return (h, y, m) => {
          const M = typeof y == "string" && y.includes(u.arrayFormatSeparator), $ = typeof y == "string" && !M && p(y, u).includes(u.arrayFormatSeparator);
          y = $ ? p(y, u) : y;
          const x = M || $ ? y.split(u.arrayFormatSeparator).map((I) => p(I, u)) : y === null ? y : p(y, u);
          m[h] = x;
        };
      case "bracket-separator":
        return (h, y, m) => {
          const M = /(\[\])$/.test(h);
          if (h = h.replace(/\[\]$/, ""), !M) {
            m[h] = y && p(y, u);
            return;
          }
          const $ = y === null ? [] : y.split(u.arrayFormatSeparator).map((x) => p(x, u));
          if (m[h] === void 0) {
            m[h] = $;
            return;
          }
          m[h] = [].concat(m[h], $);
        };
      default:
        return (h, y, m) => {
          if (m[h] === void 0) {
            m[h] = y;
            return;
          }
          m[h] = [].concat(m[h], y);
        };
    }
  }
  function f(u) {
    if (typeof u != "string" || u.length !== 1)
      throw new TypeError("arrayFormatSeparator must be single character string");
  }
  function d(u, l) {
    return l.encode ? l.strict ? t(u) : encodeURIComponent(u) : u;
  }
  function p(u, l) {
    return l.decode ? r(u) : u;
  }
  function w(u) {
    return Array.isArray(u) ? u.sort() : typeof u == "object" ? w(Object.keys(u)).sort((l, h) => Number(l) - Number(h)).map((l) => u[l]) : u;
  }
  function A(u) {
    const l = u.indexOf("#");
    return l !== -1 && (u = u.slice(0, l)), u;
  }
  function F(u) {
    let l = "";
    const h = u.indexOf("#");
    return h !== -1 && (l = u.slice(h)), l;
  }
  function N(u) {
    u = A(u);
    const l = u.indexOf("?");
    return l === -1 ? "" : u.slice(l + 1);
  }
  function z(u, l) {
    return l.parseNumbers && !Number.isNaN(Number(u)) && typeof u == "string" && u.trim() !== "" ? u = Number(u) : l.parseBooleans && u !== null && (u.toLowerCase() === "true" || u.toLowerCase() === "false") && (u = u.toLowerCase() === "true"), u;
  }
  function D(u, l) {
    l = Object.assign({
      decode: !0,
      sort: !0,
      arrayFormat: "none",
      arrayFormatSeparator: ",",
      parseNumbers: !1,
      parseBooleans: !1
    }, l), f(l.arrayFormatSeparator);
    const h = c(l), y = /* @__PURE__ */ Object.create(null);
    if (typeof u != "string" || (u = u.trim().replace(/^[?#&]/, ""), !u))
      return y;
    for (const m of u.split("&")) {
      if (m === "")
        continue;
      let [M, $] = n(l.decode ? m.replace(/\+/g, " ") : m, "=");
      $ = $ === void 0 ? null : ["comma", "separator", "bracket-separator"].includes(l.arrayFormat) ? $ : p($, l), h(p(M, l), $, y);
    }
    for (const m of Object.keys(y)) {
      const M = y[m];
      if (typeof M == "object" && M !== null)
        for (const $ of Object.keys(M))
          M[$] = z(M[$], l);
      else
        y[m] = z(M, l);
    }
    return l.sort === !1 ? y : (l.sort === !0 ? Object.keys(y).sort() : Object.keys(y).sort(l.sort)).reduce((m, M) => {
      const $ = y[M];
      return $ && typeof $ == "object" && !Array.isArray($) ? m[M] = w($) : m[M] = $, m;
    }, /* @__PURE__ */ Object.create(null));
  }
  e.extract = N, e.parse = D, e.stringify = (u, l) => {
    if (!u)
      return "";
    l = Object.assign({
      encode: !0,
      strict: !0,
      arrayFormat: "none",
      arrayFormatSeparator: ","
    }, l), f(l.arrayFormatSeparator);
    const h = ($) => l.skipNull && i(u[$]) || l.skipEmptyString && u[$] === "", y = s(l), m = {};
    for (const $ of Object.keys(u))
      h($) || (m[$] = u[$]);
    const M = Object.keys(m);
    return l.sort !== !1 && M.sort(l.sort), M.map(($) => {
      const x = u[$];
      return x === void 0 ? "" : x === null ? d($, l) : Array.isArray(x) ? x.length === 0 && l.arrayFormat === "bracket-separator" ? d($, l) + "[]" : x.reduce(y($), []).join("&") : d($, l) + "=" + d(x, l);
    }).filter(($) => $.length > 0).join("&");
  }, e.parseUrl = (u, l) => {
    l = Object.assign({
      decode: !0
    }, l);
    const [h, y] = n(u, "#");
    return Object.assign(
      {
        url: h.split("?")[0] || "",
        query: D(N(u), l)
      },
      l && l.parseFragmentIdentifier && y ? { fragmentIdentifier: p(y, l) } : {}
    );
  }, e.stringifyUrl = (u, l) => {
    l = Object.assign({
      encode: !0,
      strict: !0,
      [o]: !0
    }, l);
    const h = A(u.url).split("?")[0] || "", y = e.extract(u.url), m = e.parse(y, { sort: !1 }), M = Object.assign(m, u.query);
    let $ = e.stringify(M, l);
    $ && ($ = `?${$}`);
    let x = F(u.url);
    return u.fragmentIdentifier && (x = `#${l[o] ? d(u.fragmentIdentifier, l) : u.fragmentIdentifier}`), `${h}${$}${x}`;
  }, e.pick = (u, l, h) => {
    h = Object.assign({
      parseFragmentIdentifier: !0,
      [o]: !1
    }, h);
    const { url: y, query: m, fragmentIdentifier: M } = e.parseUrl(u, h);
    return e.stringifyUrl({
      url: y,
      query: a(m, l),
      fragmentIdentifier: M
    }, h);
  }, e.exclude = (u, l, h) => {
    const y = Array.isArray(l) ? (m) => !l.includes(m) : (m, M) => !l(m, M);
    return e.pick(u, y, h);
  };
})(hr);
class Ai {
  constructor(t) {
    this.imaginaryUrl = t, this.getSrcSetString = ({ image1x: r, image2x: n, image3x: a, image4x: i }) => `${r} 1x, ${n} 2x, ${a} 3x, ${i} 4x`, this.imaginaryUrl = t.replace(/\/$/, "");
  }
  smartcrop(t, r) {
    this.validateDimensions(r);
    const n = this.buildWithQueryParams({
      url: t,
      type: "auto",
      ...r
    });
    return `${this.imaginaryUrl}/${me.SMARTCROP}?${n}`;
  }
  crop(t, r) {
    this.validateDimensions(r);
    const n = this.buildWithQueryParams({
      url: t,
      type: "auto",
      ...r
    });
    return `${this.imaginaryUrl}/${me.CROP}?${n}`;
  }
  resize(t, r) {
    this.validateDimensions(r);
    const n = this.buildWithQueryParams({
      url: t,
      type: "auto",
      ...r,
      nocrop: !0
    });
    return `${this.imaginaryUrl}/${me.RESIZE}?${n}`;
  }
  convert(t, r) {
    const n = this.buildWithQueryParams({
      url: t,
      type: "auto",
      ...r
    });
    return `${this.imaginaryUrl}/${me.CONVERT}?${n}`;
  }
  pipe(t, r) {
    if (r.length > 10)
      throw new Error("pipe method is limited to 10 operations maximum");
    const n = this.buildWithQueryParams({
      url: t,
      type: "auto",
      operations: JSON.stringify(r)
    });
    return `${this.imaginaryUrl}/pipeline?${n}`;
  }
  validateDimensions(t) {
    if (!t.width && !t.height)
      throw new Error("dimensions should have at least a width or an height");
  }
  buildWithQueryParams(t) {
    return hr.stringify(t);
  }
  getSrcSet(t, r) {
    const n = {
      type: "auto",
      quality: r.quality
    }, a = this.resize(t, {
      ...n,
      width: r.width,
      ...r.height ? { height: r.height } : {}
    }), i = this.resize(t, {
      ...n,
      width: r.width * 2,
      ...r.height ? { height: r.height * 2 } : {}
    }), o = this.resize(t, {
      ...n,
      width: r.width * 3,
      ...r.height ? { height: r.height * 3 } : {}
    }), s = this.resize(t, {
      ...n,
      width: r.width * 4,
      ...r.height ? { height: r.height * 4 } : {}
    });
    return { image1x: a, image2x: i, image3x: o, image4x: s };
  }
  getSrcSetSmartCrop(t, r) {
    const n = {
      type: "auto",
      quality: r.quality
    }, a = this.smartcrop(t, {
      ...n,
      width: r.width,
      ...r.height ? { height: r.height } : {}
    }), i = this.smartcrop(t, {
      ...n,
      width: r.width * 2,
      ...r.height ? { height: r.height * 2 } : {}
    }), o = this.smartcrop(t, {
      ...n,
      width: r.width * 3,
      ...r.height ? { height: r.height * 3 } : {}
    }), s = this.smartcrop(t, {
      ...n,
      width: r.width * 4,
      ...r.height ? { height: r.height * 4 } : {}
    });
    return { image1x: a, image2x: i, image3x: o, image4x: s };
  }
}
var X;
(function(e) {
  e.Media = "media", e.Header = "header", e.Footer = "footer", e.Event = "event", e.Sidebar = "sidebar", e.Survey = "survey";
})(X || (X = {}));
const _ = {
  local: "staging",
  staging: "staging",
  dev: "staging",
  prod: "latest"
}, Yr = (e) => ({
  [X.Header]: {
    module: `https://storage.googleapis.com/cdn-wizbii/interservices-header/${_[e]}/interservices-header/interservices-header.esm.js`,
    noModule: `https://storage.googleapis.com/cdn-wizbii/interservices-header/${_[e]}/interservices-header/interservices-header.js`,
    hydrate: `https://storage.googleapis.com/cdn-wizbii/interservices-header/${_[e]}/hydrate/index.js`,
    namespace: "interservices-header"
  },
  [X.Footer]: {
    module: `https://storage.googleapis.com/cdn-wizbii/footer/${_[e]}/footer/footer.esm.js`,
    noModule: `https://storage.googleapis.com/cdn-wizbii/footer/${_[e]}/footer/footer.js`,
    hydrate: `https://storage.googleapis.com/cdn-wizbii/footer/${_[e]}/hydrate/index.js`,
    namespace: "footer"
  },
  [X.Event]: {
    module: `https://storage.googleapis.com/cdn-wizbii/event/${_[e]}/event/event.esm.js`,
    noModule: `https://storage.googleapis.com/cdn-wizbii/event/${_[e]}/event/event.js`,
    hydrate: `https://storage.googleapis.com/cdn-wizbii/event/${_[e]}/hydrate/index.js`,
    namespace: "event"
  },
  [X.Media]: {
    module: `https://storage.googleapis.com/cdn-wizbii/media/${_[e]}/media/media.esm.js`,
    noModule: `https://storage.googleapis.com/cdn-wizbii/media/${_[e]}/media/media.js`,
    hydrate: `https://storage.googleapis.com/cdn-wizbii/media/${_[e]}/hydrate/index.js`,
    namespace: "media"
  },
  [X.Sidebar]: {
    module: `https://storage.googleapis.com/cdn-wizbii/sidebar-component/${_[e]}/sidebar-component/sidebar-component.esm.js`,
    noModule: `https://storage.googleapis.com/cdn-wizbii/sidebar-component/${_[e]}/sidebar-component/sidebar-component.js`,
    hydrate: `https://storage.googleapis.com/cdn-wizbii/sidebar-component/${_[e]}/hydrate/index.js`,
    namespace: "sidebar-component"
  },
  [X.Survey]: {
    module: `https://storage.googleapis.com/cdn-wizbii/survey/${_[e]}/survey/survey.esm.js`,
    noModule: `https://storage.googleapis.com/cdn-wizbii/survey/${_[e]}/survey/survey.js`,
    hydrate: `https://storage.googleapis.com/cdn-wizbii/survey/${_[e]}/hydrate/index.js`,
    namespace: "survey"
  }
}), Zr = "<!-- @web-components.inject -->", Kr = (e) => {
  const t = Yr(e);
  return Object.values(X).reduce((r, n) => ({
    ...r,
    [n]: `<script
    src="${t[n].module}"
    data-stencil-namespace="${t[n].namespace}"
    type="module"
    defer
  ><\/script>
  <script
    src="${t[n].noModule}"
    data-stencil-namespace="${t[n].namespace}"
    nomodule
    defer
  ><\/script>`
  }), {});
};
function Ei(e, t, r) {
  if (!_[r])
    throw new Error("[inject-web-component] Platform does not exists");
  const n = Kr(r), a = t.reduce((i, o) => {
    if (!n[o])
      throw new Error(`[inject-web-component] ${o} is unknown`);
    return `${i}${n[o]}`;
  }, "");
  return e.replace(Zr, a);
}
class gr {
  constructor(t, r, n, a, i = "/", o, s = !0) {
    this.name = t, this.value = r, this.days = n, this.domain = a, this.path = i, this.sameSite = o, this.secure = s;
  }
  getCookie(t) {
    if (!t)
      return null;
    const r = t.match(new RegExp("(^| )" + this.name + "=([^;]+)"));
    return r && r[2] ? (this.value = r[2], r[2]) : null;
  }
  parseToString() {
    let t = "";
    if (this.days) {
      const n = /* @__PURE__ */ new Date();
      n.setTime(n.getTime() + this.days * 24 * 60 * 60 * 1e3), t = "; expires=" + n.toUTCString();
    }
    let r = `${this.name}=${this.value + t}`;
    if (this.domain) {
      const n = this.domain.startsWith(".") ? this.domain : `.${this.domain}`;
      r = `${r}; domain=${n}`;
    }
    return this.path && (r = `${r}; path=${this.path}`), !this.secure && this.sameSite === "None" && (this.secure = !0), this.secure && (r = `${r}; secure`), this.sameSite && (r = `${r}; sameSite=${this.sameSite}`), r;
  }
}
function Ti(e, t, r) {
  let n = null;
  const a = {
    method: r
  }, i = {
    "Content-Type": "application/json"
  };
  if (e) {
    const o = new gr(t);
    o.getCookie(e), o && (o != null && o.value) && (n = JSON.parse(decodeURIComponent(o.value)));
  }
  return n && a.headers && (i.Authorization = `Bearer ${n.token}`), a.headers = i, a;
}
function Xr(e) {
  const t = e.split(".")[1];
  if (!t)
    return null;
  const r = t.replace("-", "+").replace("_", "/");
  return r ? JSON.parse(atob(r)) : null;
}
function xi(e, t) {
  const r = new gr(e);
  if (r.getCookie(t), !r.value)
    return null;
  try {
    const n = JSON.parse(decodeURIComponent(r.value));
    if (n != null && n.token)
      return Xr(n.token);
  } catch (n) {
    throw new Error("Error while getting jwt", n.message);
  }
  return null;
}
var ht = {}, en = {
  get exports() {
    return ht;
  },
  set exports(e) {
    ht = e;
  }
};
(function(e, t) {
  (function(r, n) {
    e.exports = n();
  })(zr, function() {
    var r = 1e3, n = 6e4, a = 36e5, i = "millisecond", o = "second", s = "minute", c = "hour", f = "day", d = "week", p = "month", w = "quarter", A = "year", F = "date", N = "Invalid Date", z = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, D = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, u = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(b) {
      var v = ["th", "st", "nd", "rd"], g = b % 100;
      return "[" + b + (v[(g - 20) % 10] || v[g] || v[0]) + "]";
    } }, l = function(b, v, g) {
      var O = String(b);
      return !O || O.length >= v ? b : "" + Array(v + 1 - O.length).join(g) + b;
    }, h = { s: l, z: function(b) {
      var v = -b.utcOffset(), g = Math.abs(v), O = Math.floor(g / 60), S = g % 60;
      return (v <= 0 ? "+" : "-") + l(O, 2, "0") + ":" + l(S, 2, "0");
    }, m: function b(v, g) {
      if (v.date() < g.date())
        return -b(g, v);
      var O = 12 * (g.year() - v.year()) + (g.month() - v.month()), S = v.clone().add(O, p), T = g - S < 0, E = v.clone().add(O + (T ? -1 : 1), p);
      return +(-(O + (g - S) / (T ? S - E : E - S)) || 0);
    }, a: function(b) {
      return b < 0 ? Math.ceil(b) || 0 : Math.floor(b);
    }, p: function(b) {
      return { M: p, y: A, w: d, d: f, D: F, h: c, m: s, s: o, ms: i, Q: w }[b] || String(b || "").toLowerCase().replace(/s$/, "");
    }, u: function(b) {
      return b === void 0;
    } }, y = "en", m = {};
    m[y] = u;
    var M = function(b) {
      return b instanceof Q;
    }, $ = function b(v, g, O) {
      var S;
      if (!v)
        return y;
      if (typeof v == "string") {
        var T = v.toLowerCase();
        m[T] && (S = T), g && (m[T] = g, S = T);
        var E = v.split("-");
        if (!S && E.length > 1)
          return b(E[0]);
      } else {
        var P = v.name;
        m[P] = v, S = P;
      }
      return !O && S && (y = S), S || !O && y;
    }, x = function(b, v) {
      if (M(b))
        return b.clone();
      var g = typeof v == "object" ? v : {};
      return g.date = b, g.args = arguments, new Q(g);
    }, I = h;
    I.l = $, I.i = M, I.w = function(b, v) {
      return x(b, { locale: v.$L, utc: v.$u, x: v.$x, $offset: v.$offset });
    };
    var Q = function() {
      function b(g) {
        this.$L = $(g.locale, null, !0), this.parse(g);
      }
      var v = b.prototype;
      return v.parse = function(g) {
        this.$d = function(O) {
          var S = O.date, T = O.utc;
          if (S === null)
            return /* @__PURE__ */ new Date(NaN);
          if (I.u(S))
            return /* @__PURE__ */ new Date();
          if (S instanceof Date)
            return new Date(S);
          if (typeof S == "string" && !/Z$/i.test(S)) {
            var E = S.match(z);
            if (E) {
              var P = E[2] - 1 || 0, L = (E[7] || "0").substring(0, 3);
              return T ? new Date(Date.UTC(E[1], P, E[3] || 1, E[4] || 0, E[5] || 0, E[6] || 0, L)) : new Date(E[1], P, E[3] || 1, E[4] || 0, E[5] || 0, E[6] || 0, L);
            }
          }
          return new Date(S);
        }(g), this.$x = g.x || {}, this.init();
      }, v.init = function() {
        var g = this.$d;
        this.$y = g.getFullYear(), this.$M = g.getMonth(), this.$D = g.getDate(), this.$W = g.getDay(), this.$H = g.getHours(), this.$m = g.getMinutes(), this.$s = g.getSeconds(), this.$ms = g.getMilliseconds();
      }, v.$utils = function() {
        return I;
      }, v.isValid = function() {
        return this.$d.toString() !== N;
      }, v.isSame = function(g, O) {
        var S = x(g);
        return this.startOf(O) <= S && S <= this.endOf(O);
      }, v.isAfter = function(g, O) {
        return x(g) < this.startOf(O);
      }, v.isBefore = function(g, O) {
        return this.endOf(O) < x(g);
      }, v.$g = function(g, O, S) {
        return I.u(g) ? this[O] : this.set(S, g);
      }, v.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, v.valueOf = function() {
        return this.$d.getTime();
      }, v.startOf = function(g, O) {
        var S = this, T = !!I.u(O) || O, E = I.p(g), P = function(de, H) {
          var re = I.w(S.$u ? Date.UTC(S.$y, H, de) : new Date(S.$y, H, de), S);
          return T ? re : re.endOf(f);
        }, L = function(de, H) {
          return I.w(S.toDate()[de].apply(S.toDate("s"), (T ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(H)), S);
        }, R = this.$W, U = this.$M, te = this.$D, K = "set" + (this.$u ? "UTC" : "");
        switch (E) {
          case A:
            return T ? P(1, 0) : P(31, 11);
          case p:
            return T ? P(1, U) : P(0, U + 1);
          case d:
            var Ee = this.$locale().weekStart || 0, Te = (R < Ee ? R + 7 : R) - Ee;
            return P(T ? te - Te : te + (6 - Te), U);
          case f:
          case F:
            return L(K + "Hours", 0);
          case c:
            return L(K + "Minutes", 1);
          case s:
            return L(K + "Seconds", 2);
          case o:
            return L(K + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, v.endOf = function(g) {
        return this.startOf(g, !1);
      }, v.$set = function(g, O) {
        var S, T = I.p(g), E = "set" + (this.$u ? "UTC" : ""), P = (S = {}, S[f] = E + "Date", S[F] = E + "Date", S[p] = E + "Month", S[A] = E + "FullYear", S[c] = E + "Hours", S[s] = E + "Minutes", S[o] = E + "Seconds", S[i] = E + "Milliseconds", S)[T], L = T === f ? this.$D + (O - this.$W) : O;
        if (T === p || T === A) {
          var R = this.clone().set(F, 1);
          R.$d[P](L), R.init(), this.$d = R.set(F, Math.min(this.$D, R.daysInMonth())).$d;
        } else
          P && this.$d[P](L);
        return this.init(), this;
      }, v.set = function(g, O) {
        return this.clone().$set(g, O);
      }, v.get = function(g) {
        return this[I.p(g)]();
      }, v.add = function(g, O) {
        var S, T = this;
        g = Number(g);
        var E = I.p(O), P = function(U) {
          var te = x(T);
          return I.w(te.date(te.date() + Math.round(U * g)), T);
        };
        if (E === p)
          return this.set(p, this.$M + g);
        if (E === A)
          return this.set(A, this.$y + g);
        if (E === f)
          return P(1);
        if (E === d)
          return P(7);
        var L = (S = {}, S[s] = n, S[c] = a, S[o] = r, S)[E] || 1, R = this.$d.getTime() + g * L;
        return I.w(R, this);
      }, v.subtract = function(g, O) {
        return this.add(-1 * g, O);
      }, v.format = function(g) {
        var O = this, S = this.$locale();
        if (!this.isValid())
          return S.invalidDate || N;
        var T = g || "YYYY-MM-DDTHH:mm:ssZ", E = I.z(this), P = this.$H, L = this.$m, R = this.$M, U = S.weekdays, te = S.months, K = function(H, re, Xe, _e) {
          return H && (H[re] || H(O, T)) || Xe[re].slice(0, _e);
        }, Ee = function(H) {
          return I.s(P % 12 || 12, H, "0");
        }, Te = S.meridiem || function(H, re, Xe) {
          var _e = H < 12 ? "AM" : "PM";
          return Xe ? _e.toLowerCase() : _e;
        }, de = { YY: String(this.$y).slice(-2), YYYY: this.$y, M: R + 1, MM: I.s(R + 1, 2, "0"), MMM: K(S.monthsShort, R, te, 3), MMMM: K(te, R), D: this.$D, DD: I.s(this.$D, 2, "0"), d: String(this.$W), dd: K(S.weekdaysMin, this.$W, U, 2), ddd: K(S.weekdaysShort, this.$W, U, 3), dddd: U[this.$W], H: String(P), HH: I.s(P, 2, "0"), h: Ee(1), hh: Ee(2), a: Te(P, L, !0), A: Te(P, L, !1), m: String(L), mm: I.s(L, 2, "0"), s: String(this.$s), ss: I.s(this.$s, 2, "0"), SSS: I.s(this.$ms, 3, "0"), Z: E };
        return T.replace(D, function(H, re) {
          return re || de[H] || E.replace(":", "");
        });
      }, v.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, v.diff = function(g, O, S) {
        var T, E = I.p(O), P = x(g), L = (P.utcOffset() - this.utcOffset()) * n, R = this - P, U = I.m(this, P);
        return U = (T = {}, T[A] = U / 12, T[p] = U, T[w] = U / 3, T[d] = (R - L) / 6048e5, T[f] = (R - L) / 864e5, T[c] = R / a, T[s] = R / n, T[o] = R / r, T)[E] || R, S ? U : I.a(U);
      }, v.daysInMonth = function() {
        return this.endOf(p).$D;
      }, v.$locale = function() {
        return m[this.$L];
      }, v.locale = function(g, O) {
        if (!g)
          return this.$L;
        var S = this.clone(), T = $(g, O, !0);
        return T && (S.$L = T), S;
      }, v.clone = function() {
        return I.w(this.$d, this);
      }, v.toDate = function() {
        return new Date(this.valueOf());
      }, v.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, v.toISOString = function() {
        return this.$d.toISOString();
      }, v.toString = function() {
        return this.$d.toUTCString();
      }, b;
    }(), k = Q.prototype;
    return x.prototype = k, [["$ms", i], ["$s", o], ["$m", s], ["$H", c], ["$W", f], ["$M", p], ["$y", A], ["$D", F]].forEach(function(b) {
      k[b[1]] = function(v) {
        return this.$g(v, b[0], b[1]);
      };
    }), x.extend = function(b, v) {
      return b.$i || (b(v, Q, x), b.$i = !0), x;
    }, x.locale = $, x.isDayjs = M, x.unix = function(b) {
      return x(1e3 * b);
    }, x.en = m[y], x.Ls = m, x.p = {}, x;
  });
})(en);
const ce = ht;
function tn(e) {
  var t;
  return {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    ...e.headline && { headline: e.headline },
    ...e.alternativeHeadline && {
      alternativeHeadline: e.alternativeHeadline
    },
    ...e.image && { image: e.image },
    ...e.award && { award: e.award },
    ...e.editor && { editor: e.editor },
    ...e.genre && { genre: e.genre },
    ...e.keywords && { keywords: e.keywords },
    ...e.wordCount && { wordCount: e.wordCount },
    ...e.publisher && { publisher: e.publisher },
    ...e.url && { url: e.url },
    ...e.datePublished && {
      datePublished: ce(e.datePublished).toISOString()
    },
    ...e.dateCreated && { dateCreated: ce(e.dateCreated).toISOString() },
    ...e.dateModified && {
      dateModified: ce(e.dateModified).toISOString()
    },
    ...e.description && { description: e.description },
    ...e.articleBody && { articleBody: e.articleBody },
    author: {
      "@type": "Person",
      ...((t = e.author) == null ? void 0 : t.name) && { name: e == null ? void 0 : e.author.name }
    }
  };
}
function Fi(e) {
  var t, r;
  return {
    "@context": "https://schema.org",
    "@type": "Event",
    name: e.name,
    ...e.startDate && { startDate: ce(e.startDate).toISOString() },
    ...e.endDate && { endDate: ce(e.endDate).toISOString() },
    ...e.eventAttendanceMode && { eventAttendanceMode: e.eventAttendanceMode },
    ...e.eventStatus && { eventStatus: e.eventStatus },
    ...e.image && { image: e.image },
    ...e.organizer && {
      organizer: {
        "@type": "Organization",
        name: e.organizer.name,
        url: e.organizer.url,
        ...((t = e.organizer) == null ? void 0 : t.logo) && { logo: e.organizer.logo },
        ...((r = e.organizer) == null ? void 0 : r.sameAs) && { sameAs: e.organizer.sameAs }
      }
    },
    ...e.description && {
      description: e.description
    },
    ...e.offers && {
      offers: {
        "@type": "Offer",
        url: e.offers.url,
        price: e.offers.price,
        priceCurrency: e.offers.priceCurrency,
        availability: e.offers.availability
      }
    },
    location: [
      ...(e.virtualLocation || []).map((n) => ({
        "@type": "VirtualLocation",
        url: n.url
      })),
      ...e.location.map((n) => ({
        "@type": "Place",
        name: n.name,
        ...n.geo && {
          geo: {
            "@type": "GeoCoordinates",
            latitude: n.geo.latitude,
            longitude: n.geo.longitude
          }
        },
        ...n.address && {
          address: {
            "@type": "PostalAddress",
            ...n.address.addressCountry && {
              addressCountry: n.address.addressCountry
            },
            ...n.address.addressLocality && {
              addressLocality: n.address.addressLocality
            },
            ...n.address.postalCode && { postalCode: n.address.postalCode },
            ...n.address.addressRegion && { addressRegion: n.address.addressRegion }
          }
        }
      }))
    ]
  };
}
function Mi(e) {
  const t = [];
  return e.forEach((r) => {
    t.push({
      "@type": "Question",
      name: r.name,
      acceptedAnswer: {
        "@type": "Answer",
        text: r.text
      }
    });
  }), {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: t
  };
}
function Ii(e) {
  var t, r, n, a;
  return {
    "@context": "https://schema.org",
    "@type": "JobPosting",
    datePosted: ce(e.datePosted).toISOString(),
    description: e.description,
    title: e.title,
    validThrough: ce(e.validThrough).toISOString(),
    hiringOrganization: {
      "@type": "Organization",
      name: e.hiringOrganization.name,
      sameAs: e.hiringOrganization.sameAs,
      ...((t = e.hiringOrganization) == null ? void 0 : t.logo) && { logo: e.hiringOrganization.logo }
    },
    jobLocation: {
      "@type": "Place",
      ...((r = e.jobLocation) == null ? void 0 : r.address) && {
        address: {
          "@type": "PostalAddress",
          addressCountry: e.jobLocation.address.addressCountry,
          ...((n = e.jobLocation) == null ? void 0 : n.address.addressLocality) && {
            addressLocality: e.jobLocation.address.addressLocality
          },
          postalCode: e.jobLocation.address.postalCode,
          addressRegion: e.jobLocation.address.addressRegion
        }
      },
      ...((a = e.jobLocation) == null ? void 0 : a.geo) && {
        geo: {
          "@type": "GeoCoordinates",
          latitude: e.jobLocation.geo.latitude,
          longitude: e.jobLocation.geo.longitude
        }
      }
    },
    ...e.employmentType && { employmentType: e.employmentType },
    ...e.baseSalary && {
      baseSalary: {
        "@type": "MonetaryAmount",
        currency: e.baseSalary.currency,
        value: {
          "@type": "QuantitativeValue",
          value: e.baseSalary.value.value,
          unitText: e.baseSalary.value.unitText
        }
      }
    }
  };
}
function Ci(e) {
  var t, r, n;
  return {
    "@context": "https://schema.org",
    "@type": "NewsArticle",
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": e.mainEntityOfPageId
    },
    headline: e.headline,
    ...e.image && { image: e.image },
    datePublished: e.datePublished,
    dateModified: e.dateModified,
    author: {
      "@type": "Person",
      ...e.author && { name: e.author }
    },
    publisher: {
      "@type": "Organization",
      name: (t = e.publisher) == null ? void 0 : t.name,
      ...((r = e.publisher) == null ? void 0 : r.url) && { url: e.publisher.url },
      ...((n = e.publisher) == null ? void 0 : n.logo) && { logo: e.publisher.logo }
    }
  };
}
function Di(e) {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: e.name,
    ...e.url && { url: e.url },
    ...e.logo && { logo: e.logo }
  };
}
const rn = {
  6: [1, 1, 1, 2, 2, 3, 4],
  5: [1, 1, 2, 2, 3, 4],
  4: [1, 1, 2, 3, 3],
  3: [1, 1, 2, 4],
  2: [1, 2, 3],
  1: [1, 1]
};
function et(e, t) {
  const r = e / t, n = Math.round(r + 0.01);
  return t * n;
}
function Bt(e, t, r, n = !1) {
  const a = r - t + 1, i = rn[e], o = a / i.reduce((p, w) => p + w, 0);
  let s = 0, c = 0;
  const f = [];
  for (let p = 0; p < e; p++) {
    const w = i[p];
    s += o * w;
    let A = Math.round(s);
    (A <= c || A < 1) && (A = c + 1), f.push(A), c = A;
  }
  const d = [];
  for (let p of f)
    n ? p = r + 1 - p : p = p + t - 1, a > 49 * e ? p = et(p, 50) : a > 9 * e ? p = et(p, 10) : a > 4 * e && (p = et(p, 5)), p >= t && p <= r && d.push(p);
  return d;
}
function nn(e, t) {
  return [...Array(t - e + 1).keys()].map((r) => r + e);
}
function Pi(e, t) {
  if (e < 1 && (e = 1), e > t && (e = t), t < 11)
    return nn(1, t);
  const r = {};
  for (let d = e - 2; d < e + 3; d++)
    d > 1 && d < t && (r[d] = 1);
  let n = e - 4;
  n < 0 && (n = 0);
  let a = t - e - 3;
  a < 0 && (a = 0);
  const i = n + a, o = n / i, s = a / i;
  let c = Math.round(6 * o), f = Math.round(6 * s);
  return c === 0 && n && (c = 1, f = 5), f === 0 && a && (f = 1, c = 5), e > 4 && Bt(c, 2, e - 3, !0).forEach((p) => {
    r[p] = 1;
  }), e < t - 4 && Bt(f, e + 3, t - 1).forEach((p) => {
    r[p] = 1;
  }), Object.keys(r).map((d) => parseInt(d));
}
var an = function() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var t = {}, r = Symbol("test"), n = Object(r);
  if (typeof r == "string" || Object.prototype.toString.call(r) !== "[object Symbol]" || Object.prototype.toString.call(n) !== "[object Symbol]")
    return !1;
  var a = 42;
  t[r] = a;
  for (r in t)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(t).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(t).length !== 0)
    return !1;
  var i = Object.getOwnPropertySymbols(t);
  if (i.length !== 1 || i[0] !== r || !Object.prototype.propertyIsEnumerable.call(t, r))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var o = Object.getOwnPropertyDescriptor(t, r);
    if (o.value !== a || o.enumerable !== !0)
      return !1;
  }
  return !0;
}, Ut = typeof Symbol < "u" && Symbol, on = an, sn = function() {
  return typeof Ut != "function" || typeof Symbol != "function" || typeof Ut("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : on();
}, cn = "Function.prototype.bind called on incompatible ", tt = Array.prototype.slice, un = Object.prototype.toString, fn = "[object Function]", ln = function(t) {
  var r = this;
  if (typeof r != "function" || un.call(r) !== fn)
    throw new TypeError(cn + r);
  for (var n = tt.call(arguments, 1), a, i = function() {
    if (this instanceof a) {
      var d = r.apply(
        this,
        n.concat(tt.call(arguments))
      );
      return Object(d) === d ? d : this;
    } else
      return r.apply(
        t,
        n.concat(tt.call(arguments))
      );
  }, o = Math.max(0, r.length - n.length), s = [], c = 0; c < o; c++)
    s.push("$" + c);
  if (a = Function("binder", "return function (" + s.join(",") + "){ return binder.apply(this,arguments); }")(i), r.prototype) {
    var f = function() {
    };
    f.prototype = r.prototype, a.prototype = new f(), f.prototype = null;
  }
  return a;
}, dn = ln, At = Function.prototype.bind || dn, pn = At, yn = pn.call(Function.call, Object.prototype.hasOwnProperty), C, Se = SyntaxError, vr = Function, ve = TypeError, rt = function(e) {
  try {
    return vr('"use strict"; return (' + e + ").constructor;")();
  } catch {
  }
}, ue = Object.getOwnPropertyDescriptor;
if (ue)
  try {
    ue({}, "");
  } catch {
    ue = null;
  }
var nt = function() {
  throw new ve();
}, hn = ue ? function() {
  try {
    return arguments.callee, nt;
  } catch {
    try {
      return ue(arguments, "callee").get;
    } catch {
      return nt;
    }
  }
}() : nt, pe = sn(), G = Object.getPrototypeOf || function(e) {
  return e.__proto__;
}, he = {}, mn = typeof Uint8Array > "u" ? C : G(Uint8Array), fe = {
  "%AggregateError%": typeof AggregateError > "u" ? C : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? C : ArrayBuffer,
  "%ArrayIteratorPrototype%": pe ? G([][Symbol.iterator]()) : C,
  "%AsyncFromSyncIteratorPrototype%": C,
  "%AsyncFunction%": he,
  "%AsyncGenerator%": he,
  "%AsyncGeneratorFunction%": he,
  "%AsyncIteratorPrototype%": he,
  "%Atomics%": typeof Atomics > "u" ? C : Atomics,
  "%BigInt%": typeof BigInt > "u" ? C : BigInt,
  "%BigInt64Array%": typeof BigInt64Array > "u" ? C : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array > "u" ? C : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? C : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": Error,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": EvalError,
  "%Float32Array%": typeof Float32Array > "u" ? C : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? C : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? C : FinalizationRegistry,
  "%Function%": vr,
  "%GeneratorFunction%": he,
  "%Int8Array%": typeof Int8Array > "u" ? C : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? C : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? C : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": pe ? G(G([][Symbol.iterator]())) : C,
  "%JSON%": typeof JSON == "object" ? JSON : C,
  "%Map%": typeof Map > "u" ? C : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !pe ? C : G((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? C : Promise,
  "%Proxy%": typeof Proxy > "u" ? C : Proxy,
  "%RangeError%": RangeError,
  "%ReferenceError%": ReferenceError,
  "%Reflect%": typeof Reflect > "u" ? C : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? C : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !pe ? C : G((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? C : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": pe ? G(""[Symbol.iterator]()) : C,
  "%Symbol%": pe ? Symbol : C,
  "%SyntaxError%": Se,
  "%ThrowTypeError%": hn,
  "%TypedArray%": mn,
  "%TypeError%": ve,
  "%Uint8Array%": typeof Uint8Array > "u" ? C : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? C : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? C : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? C : Uint32Array,
  "%URIError%": URIError,
  "%WeakMap%": typeof WeakMap > "u" ? C : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? C : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? C : WeakSet
};
try {
  null.error;
} catch (e) {
  var gn = G(G(e));
  fe["%Error.prototype%"] = gn;
}
var vn = function e(t) {
  var r;
  if (t === "%AsyncFunction%")
    r = rt("async function () {}");
  else if (t === "%GeneratorFunction%")
    r = rt("function* () {}");
  else if (t === "%AsyncGeneratorFunction%")
    r = rt("async function* () {}");
  else if (t === "%AsyncGenerator%") {
    var n = e("%AsyncGeneratorFunction%");
    n && (r = n.prototype);
  } else if (t === "%AsyncIteratorPrototype%") {
    var a = e("%AsyncGenerator%");
    a && (r = G(a.prototype));
  }
  return fe[t] = r, r;
}, Wt = {
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, Re = At, ke = yn, Sn = Re.call(Function.call, Array.prototype.concat), wn = Re.call(Function.apply, Array.prototype.splice), jt = Re.call(Function.call, String.prototype.replace), He = Re.call(Function.call, String.prototype.slice), $n = Re.call(Function.call, RegExp.prototype.exec), bn = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, On = /\\(\\)?/g, An = function(t) {
  var r = He(t, 0, 1), n = He(t, -1);
  if (r === "%" && n !== "%")
    throw new Se("invalid intrinsic syntax, expected closing `%`");
  if (n === "%" && r !== "%")
    throw new Se("invalid intrinsic syntax, expected opening `%`");
  var a = [];
  return jt(t, bn, function(i, o, s, c) {
    a[a.length] = s ? jt(c, On, "$1") : o || i;
  }), a;
}, En = function(t, r) {
  var n = t, a;
  if (ke(Wt, n) && (a = Wt[n], n = "%" + a[0] + "%"), ke(fe, n)) {
    var i = fe[n];
    if (i === he && (i = vn(n)), typeof i > "u" && !r)
      throw new ve("intrinsic " + t + " exists, but is not available. Please file an issue!");
    return {
      alias: a,
      name: n,
      value: i
    };
  }
  throw new Se("intrinsic " + t + " does not exist!");
}, Et = function(t, r) {
  if (typeof t != "string" || t.length === 0)
    throw new ve("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof r != "boolean")
    throw new ve('"allowMissing" argument must be a boolean');
  if ($n(/^%?[^%]*%?$/, t) === null)
    throw new Se("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var n = An(t), a = n.length > 0 ? n[0] : "", i = En("%" + a + "%", r), o = i.name, s = i.value, c = !1, f = i.alias;
  f && (a = f[0], wn(n, Sn([0, 1], f)));
  for (var d = 1, p = !0; d < n.length; d += 1) {
    var w = n[d], A = He(w, 0, 1), F = He(w, -1);
    if ((A === '"' || A === "'" || A === "`" || F === '"' || F === "'" || F === "`") && A !== F)
      throw new Se("property names with quotes must have matching quotes");
    if ((w === "constructor" || !p) && (c = !0), a += "." + w, o = "%" + a + "%", ke(fe, o))
      s = fe[o];
    else if (s != null) {
      if (!(w in s)) {
        if (!r)
          throw new ve("base intrinsic for " + t + " exists, but the property is not available.");
        return;
      }
      if (ue && d + 1 >= n.length) {
        var N = ue(s, w);
        p = !!N, p && "get" in N && !("originalValue" in N.get) ? s = N.get : s = s[w];
      } else
        p = ke(s, w), s = s[w];
      p && !c && (fe[o] = s);
    }
  }
  return s;
}, mt = {}, Tn = {
  get exports() {
    return mt;
  },
  set exports(e) {
    mt = e;
  }
};
(function(e) {
  var t = At, r = Et, n = r("%Function.prototype.apply%"), a = r("%Function.prototype.call%"), i = r("%Reflect.apply%", !0) || t.call(a, n), o = r("%Object.getOwnPropertyDescriptor%", !0), s = r("%Object.defineProperty%", !0), c = r("%Math.max%");
  if (s)
    try {
      s({}, "a", { value: 1 });
    } catch {
      s = null;
    }
  e.exports = function(p) {
    var w = i(t, a, arguments);
    if (o && s) {
      var A = o(w, "length");
      A.configurable && s(
        w,
        "length",
        { value: 1 + c(0, p.length - (arguments.length - 1)) }
      );
    }
    return w;
  };
  var f = function() {
    return i(t, n, arguments);
  };
  s ? s(e.exports, "apply", { value: f }) : e.exports.apply = f;
})(Tn);
var Sr = Et, wr = mt, xn = wr(Sr("String.prototype.indexOf")), Fn = function(t, r) {
  var n = Sr(t, !!r);
  return typeof n == "function" && xn(t, ".prototype.") > -1 ? wr(n) : n;
};
const Mn = {}, In = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Mn
}, Symbol.toStringTag, { value: "Module" })), Cn = /* @__PURE__ */ kr(In);
var Tt = typeof Map == "function" && Map.prototype, at = Object.getOwnPropertyDescriptor && Tt ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, qe = Tt && at && typeof at.get == "function" ? at.get : null, zt = Tt && Map.prototype.forEach, xt = typeof Set == "function" && Set.prototype, it = Object.getOwnPropertyDescriptor && xt ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, Ve = xt && it && typeof it.get == "function" ? it.get : null, kt = xt && Set.prototype.forEach, Dn = typeof WeakMap == "function" && WeakMap.prototype, Me = Dn ? WeakMap.prototype.has : null, Pn = typeof WeakSet == "function" && WeakSet.prototype, Ie = Pn ? WeakSet.prototype.has : null, Rn = typeof WeakRef == "function" && WeakRef.prototype, Ht = Rn ? WeakRef.prototype.deref : null, Nn = Boolean.prototype.valueOf, Ln = Object.prototype.toString, _n = Function.prototype.toString, Bn = String.prototype.match, Ft = String.prototype.slice, ie = String.prototype.replace, Un = String.prototype.toUpperCase, qt = String.prototype.toLowerCase, $r = RegExp.prototype.test, Vt = Array.prototype.concat, Y = Array.prototype.join, Wn = Array.prototype.slice, Qt = Math.floor, gt = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, ot = Object.getOwnPropertySymbols, vt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, we = typeof Symbol == "function" && typeof Symbol.iterator == "object", j = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === we || "symbol") ? Symbol.toStringTag : null, br = Object.prototype.propertyIsEnumerable, Jt = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(e) {
  return e.__proto__;
} : null);
function Gt(e, t) {
  if (e === 1 / 0 || e === -1 / 0 || e !== e || e && e > -1e3 && e < 1e3 || $r.call(/e/, t))
    return t;
  var r = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
  if (typeof e == "number") {
    var n = e < 0 ? -Qt(-e) : Qt(e);
    if (n !== e) {
      var a = String(n), i = Ft.call(t, a.length + 1);
      return ie.call(a, r, "$&_") + "." + ie.call(ie.call(i, /([0-9]{3})/g, "$&_"), /_$/, "");
    }
  }
  return ie.call(t, r, "$&_");
}
var St = Cn, Yt = St.custom, Zt = Ar(Yt) ? Yt : null, jn = function e(t, r, n, a) {
  var i = r || {};
  if (ne(i, "quoteStyle") && i.quoteStyle !== "single" && i.quoteStyle !== "double")
    throw new TypeError('option "quoteStyle" must be "single" or "double"');
  if (ne(i, "maxStringLength") && (typeof i.maxStringLength == "number" ? i.maxStringLength < 0 && i.maxStringLength !== 1 / 0 : i.maxStringLength !== null))
    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
  var o = ne(i, "customInspect") ? i.customInspect : !0;
  if (typeof o != "boolean" && o !== "symbol")
    throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
  if (ne(i, "indent") && i.indent !== null && i.indent !== "	" && !(parseInt(i.indent, 10) === i.indent && i.indent > 0))
    throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
  if (ne(i, "numericSeparator") && typeof i.numericSeparator != "boolean")
    throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
  var s = i.numericSeparator;
  if (typeof t > "u")
    return "undefined";
  if (t === null)
    return "null";
  if (typeof t == "boolean")
    return t ? "true" : "false";
  if (typeof t == "string")
    return Tr(t, i);
  if (typeof t == "number") {
    if (t === 0)
      return 1 / 0 / t > 0 ? "0" : "-0";
    var c = String(t);
    return s ? Gt(t, c) : c;
  }
  if (typeof t == "bigint") {
    var f = String(t) + "n";
    return s ? Gt(t, f) : f;
  }
  var d = typeof i.depth > "u" ? 5 : i.depth;
  if (typeof n > "u" && (n = 0), n >= d && d > 0 && typeof t == "object")
    return wt(t) ? "[Array]" : "[Object]";
  var p = ia(i, n);
  if (typeof a > "u")
    a = [];
  else if (Er(a, t) >= 0)
    return "[Circular]";
  function w(b, v, g) {
    if (v && (a = Wn.call(a), a.push(v)), g) {
      var O = {
        depth: i.depth
      };
      return ne(i, "quoteStyle") && (O.quoteStyle = i.quoteStyle), e(b, O, n + 1, a);
    }
    return e(b, i, n + 1, a);
  }
  if (typeof t == "function" && !Kt(t)) {
    var A = Yn(t), F = Be(t, w);
    return "[Function" + (A ? ": " + A : " (anonymous)") + "]" + (F.length > 0 ? " { " + Y.call(F, ", ") + " }" : "");
  }
  if (Ar(t)) {
    var N = we ? ie.call(String(t), /^(Symbol\(.*\))_[^)]*$/, "$1") : vt.call(t);
    return typeof t == "object" && !we ? xe(N) : N;
  }
  if (ra(t)) {
    for (var z = "<" + qt.call(String(t.nodeName)), D = t.attributes || [], u = 0; u < D.length; u++)
      z += " " + D[u].name + "=" + Or(zn(D[u].value), "double", i);
    return z += ">", t.childNodes && t.childNodes.length && (z += "..."), z += "</" + qt.call(String(t.nodeName)) + ">", z;
  }
  if (wt(t)) {
    if (t.length === 0)
      return "[]";
    var l = Be(t, w);
    return p && !aa(l) ? "[" + $t(l, p) + "]" : "[ " + Y.call(l, ", ") + " ]";
  }
  if (Hn(t)) {
    var h = Be(t, w);
    return !("cause" in Error.prototype) && "cause" in t && !br.call(t, "cause") ? "{ [" + String(t) + "] " + Y.call(Vt.call("[cause]: " + w(t.cause), h), ", ") + " }" : h.length === 0 ? "[" + String(t) + "]" : "{ [" + String(t) + "] " + Y.call(h, ", ") + " }";
  }
  if (typeof t == "object" && o) {
    if (Zt && typeof t[Zt] == "function" && St)
      return St(t, { depth: d - n });
    if (o !== "symbol" && typeof t.inspect == "function")
      return t.inspect();
  }
  if (Zn(t)) {
    var y = [];
    return zt && zt.call(t, function(b, v) {
      y.push(w(v, t, !0) + " => " + w(b, t));
    }), Xt("Map", qe.call(t), y, p);
  }
  if (ea(t)) {
    var m = [];
    return kt && kt.call(t, function(b) {
      m.push(w(b, t));
    }), Xt("Set", Ve.call(t), m, p);
  }
  if (Kn(t))
    return st("WeakMap");
  if (ta(t))
    return st("WeakSet");
  if (Xn(t))
    return st("WeakRef");
  if (Vn(t))
    return xe(w(Number(t)));
  if (Jn(t))
    return xe(w(gt.call(t)));
  if (Qn(t))
    return xe(Nn.call(t));
  if (qn(t))
    return xe(w(String(t)));
  if (!kn(t) && !Kt(t)) {
    var M = Be(t, w), $ = Jt ? Jt(t) === Object.prototype : t instanceof Object || t.constructor === Object, x = t instanceof Object ? "" : "null prototype", I = !$ && j && Object(t) === t && j in t ? Ft.call(oe(t), 8, -1) : x ? "Object" : "", Q = $ || typeof t.constructor != "function" ? "" : t.constructor.name ? t.constructor.name + " " : "", k = Q + (I || x ? "[" + Y.call(Vt.call([], I || [], x || []), ": ") + "] " : "");
    return M.length === 0 ? k + "{}" : p ? k + "{" + $t(M, p) + "}" : k + "{ " + Y.call(M, ", ") + " }";
  }
  return String(t);
};
function Or(e, t, r) {
  var n = (r.quoteStyle || t) === "double" ? '"' : "'";
  return n + e + n;
}
function zn(e) {
  return ie.call(String(e), /"/g, "&quot;");
}
function wt(e) {
  return oe(e) === "[object Array]" && (!j || !(typeof e == "object" && j in e));
}
function kn(e) {
  return oe(e) === "[object Date]" && (!j || !(typeof e == "object" && j in e));
}
function Kt(e) {
  return oe(e) === "[object RegExp]" && (!j || !(typeof e == "object" && j in e));
}
function Hn(e) {
  return oe(e) === "[object Error]" && (!j || !(typeof e == "object" && j in e));
}
function qn(e) {
  return oe(e) === "[object String]" && (!j || !(typeof e == "object" && j in e));
}
function Vn(e) {
  return oe(e) === "[object Number]" && (!j || !(typeof e == "object" && j in e));
}
function Qn(e) {
  return oe(e) === "[object Boolean]" && (!j || !(typeof e == "object" && j in e));
}
function Ar(e) {
  if (we)
    return e && typeof e == "object" && e instanceof Symbol;
  if (typeof e == "symbol")
    return !0;
  if (!e || typeof e != "object" || !vt)
    return !1;
  try {
    return vt.call(e), !0;
  } catch {
  }
  return !1;
}
function Jn(e) {
  if (!e || typeof e != "object" || !gt)
    return !1;
  try {
    return gt.call(e), !0;
  } catch {
  }
  return !1;
}
var Gn = Object.prototype.hasOwnProperty || function(e) {
  return e in this;
};
function ne(e, t) {
  return Gn.call(e, t);
}
function oe(e) {
  return Ln.call(e);
}
function Yn(e) {
  if (e.name)
    return e.name;
  var t = Bn.call(_n.call(e), /^function\s*([\w$]+)/);
  return t ? t[1] : null;
}
function Er(e, t) {
  if (e.indexOf)
    return e.indexOf(t);
  for (var r = 0, n = e.length; r < n; r++)
    if (e[r] === t)
      return r;
  return -1;
}
function Zn(e) {
  if (!qe || !e || typeof e != "object")
    return !1;
  try {
    qe.call(e);
    try {
      Ve.call(e);
    } catch {
      return !0;
    }
    return e instanceof Map;
  } catch {
  }
  return !1;
}
function Kn(e) {
  if (!Me || !e || typeof e != "object")
    return !1;
  try {
    Me.call(e, Me);
    try {
      Ie.call(e, Ie);
    } catch {
      return !0;
    }
    return e instanceof WeakMap;
  } catch {
  }
  return !1;
}
function Xn(e) {
  if (!Ht || !e || typeof e != "object")
    return !1;
  try {
    return Ht.call(e), !0;
  } catch {
  }
  return !1;
}
function ea(e) {
  if (!Ve || !e || typeof e != "object")
    return !1;
  try {
    Ve.call(e);
    try {
      qe.call(e);
    } catch {
      return !0;
    }
    return e instanceof Set;
  } catch {
  }
  return !1;
}
function ta(e) {
  if (!Ie || !e || typeof e != "object")
    return !1;
  try {
    Ie.call(e, Ie);
    try {
      Me.call(e, Me);
    } catch {
      return !0;
    }
    return e instanceof WeakSet;
  } catch {
  }
  return !1;
}
function ra(e) {
  return !e || typeof e != "object" ? !1 : typeof HTMLElement < "u" && e instanceof HTMLElement ? !0 : typeof e.nodeName == "string" && typeof e.getAttribute == "function";
}
function Tr(e, t) {
  if (e.length > t.maxStringLength) {
    var r = e.length - t.maxStringLength, n = "... " + r + " more character" + (r > 1 ? "s" : "");
    return Tr(Ft.call(e, 0, t.maxStringLength), t) + n;
  }
  var a = ie.call(ie.call(e, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, na);
  return Or(a, "single", t);
}
function na(e) {
  var t = e.charCodeAt(0), r = {
    8: "b",
    9: "t",
    10: "n",
    12: "f",
    13: "r"
  }[t];
  return r ? "\\" + r : "\\x" + (t < 16 ? "0" : "") + Un.call(t.toString(16));
}
function xe(e) {
  return "Object(" + e + ")";
}
function st(e) {
  return e + " { ? }";
}
function Xt(e, t, r, n) {
  var a = n ? $t(r, n) : Y.call(r, ", ");
  return e + " (" + t + ") {" + a + "}";
}
function aa(e) {
  for (var t = 0; t < e.length; t++)
    if (Er(e[t], `
`) >= 0)
      return !1;
  return !0;
}
function ia(e, t) {
  var r;
  if (e.indent === "	")
    r = "	";
  else if (typeof e.indent == "number" && e.indent > 0)
    r = Y.call(Array(e.indent + 1), " ");
  else
    return null;
  return {
    base: r,
    prev: Y.call(Array(t + 1), r)
  };
}
function $t(e, t) {
  if (e.length === 0)
    return "";
  var r = `
` + t.prev + t.base;
  return r + Y.call(e, "," + r) + `
` + t.prev;
}
function Be(e, t) {
  var r = wt(e), n = [];
  if (r) {
    n.length = e.length;
    for (var a = 0; a < e.length; a++)
      n[a] = ne(e, a) ? t(e[a], e) : "";
  }
  var i = typeof ot == "function" ? ot(e) : [], o;
  if (we) {
    o = {};
    for (var s = 0; s < i.length; s++)
      o["$" + i[s]] = i[s];
  }
  for (var c in e)
    ne(e, c) && (r && String(Number(c)) === c && c < e.length || we && o["$" + c] instanceof Symbol || ($r.call(/[^\w$]/, c) ? n.push(t(c, e) + ": " + t(e[c], e)) : n.push(c + ": " + t(e[c], e))));
  if (typeof ot == "function")
    for (var f = 0; f < i.length; f++)
      br.call(e, i[f]) && n.push("[" + t(i[f]) + "]: " + t(e[i[f]], e));
  return n;
}
var Mt = Et, be = Fn, oa = jn, sa = Mt("%TypeError%"), Ue = Mt("%WeakMap%", !0), We = Mt("%Map%", !0), ca = be("WeakMap.prototype.get", !0), ua = be("WeakMap.prototype.set", !0), fa = be("WeakMap.prototype.has", !0), la = be("Map.prototype.get", !0), da = be("Map.prototype.set", !0), pa = be("Map.prototype.has", !0), It = function(e, t) {
  for (var r = e, n; (n = r.next) !== null; r = n)
    if (n.key === t)
      return r.next = n.next, n.next = e.next, e.next = n, n;
}, ya = function(e, t) {
  var r = It(e, t);
  return r && r.value;
}, ha = function(e, t, r) {
  var n = It(e, t);
  n ? n.value = r : e.next = {
    // eslint-disable-line no-param-reassign
    key: t,
    next: e.next,
    value: r
  };
}, ma = function(e, t) {
  return !!It(e, t);
}, ga = function() {
  var t, r, n, a = {
    assert: function(i) {
      if (!a.has(i))
        throw new sa("Side channel does not contain " + oa(i));
    },
    get: function(i) {
      if (Ue && i && (typeof i == "object" || typeof i == "function")) {
        if (t)
          return ca(t, i);
      } else if (We) {
        if (r)
          return la(r, i);
      } else if (n)
        return ya(n, i);
    },
    has: function(i) {
      if (Ue && i && (typeof i == "object" || typeof i == "function")) {
        if (t)
          return fa(t, i);
      } else if (We) {
        if (r)
          return pa(r, i);
      } else if (n)
        return ma(n, i);
      return !1;
    },
    set: function(i, o) {
      Ue && i && (typeof i == "object" || typeof i == "function") ? (t || (t = new Ue()), ua(t, i, o)) : We ? (r || (r = new We()), da(r, i, o)) : (n || (n = { key: {}, next: null }), ha(n, i, o));
    }
  };
  return a;
}, va = String.prototype.replace, Sa = /%20/g, ct = {
  RFC1738: "RFC1738",
  RFC3986: "RFC3986"
}, Ct = {
  default: ct.RFC3986,
  formatters: {
    RFC1738: function(e) {
      return va.call(e, Sa, "+");
    },
    RFC3986: function(e) {
      return String(e);
    }
  },
  RFC1738: ct.RFC1738,
  RFC3986: ct.RFC3986
}, wa = Ct, ut = Object.prototype.hasOwnProperty, se = Array.isArray, J = function() {
  for (var e = [], t = 0; t < 256; ++t)
    e.push("%" + ((t < 16 ? "0" : "") + t.toString(16)).toUpperCase());
  return e;
}(), $a = function(t) {
  for (; t.length > 1; ) {
    var r = t.pop(), n = r.obj[r.prop];
    if (se(n)) {
      for (var a = [], i = 0; i < n.length; ++i)
        typeof n[i] < "u" && a.push(n[i]);
      r.obj[r.prop] = a;
    }
  }
}, xr = function(t, r) {
  for (var n = r && r.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, a = 0; a < t.length; ++a)
    typeof t[a] < "u" && (n[a] = t[a]);
  return n;
}, ba = function e(t, r, n) {
  if (!r)
    return t;
  if (typeof r != "object") {
    if (se(t))
      t.push(r);
    else if (t && typeof t == "object")
      (n && (n.plainObjects || n.allowPrototypes) || !ut.call(Object.prototype, r)) && (t[r] = !0);
    else
      return [t, r];
    return t;
  }
  if (!t || typeof t != "object")
    return [t].concat(r);
  var a = t;
  return se(t) && !se(r) && (a = xr(t, n)), se(t) && se(r) ? (r.forEach(function(i, o) {
    if (ut.call(t, o)) {
      var s = t[o];
      s && typeof s == "object" && i && typeof i == "object" ? t[o] = e(s, i, n) : t.push(i);
    } else
      t[o] = i;
  }), t) : Object.keys(r).reduce(function(i, o) {
    var s = r[o];
    return ut.call(i, o) ? i[o] = e(i[o], s, n) : i[o] = s, i;
  }, a);
}, Oa = function(t, r) {
  return Object.keys(r).reduce(function(n, a) {
    return n[a] = r[a], n;
  }, t);
}, Aa = function(e, t, r) {
  var n = e.replace(/\+/g, " ");
  if (r === "iso-8859-1")
    return n.replace(/%[0-9a-f]{2}/gi, unescape);
  try {
    return decodeURIComponent(n);
  } catch {
    return n;
  }
}, Ea = function(t, r, n, a, i) {
  if (t.length === 0)
    return t;
  var o = t;
  if (typeof t == "symbol" ? o = Symbol.prototype.toString.call(t) : typeof t != "string" && (o = String(t)), n === "iso-8859-1")
    return escape(o).replace(/%u[0-9a-f]{4}/gi, function(d) {
      return "%26%23" + parseInt(d.slice(2), 16) + "%3B";
    });
  for (var s = "", c = 0; c < o.length; ++c) {
    var f = o.charCodeAt(c);
    if (f === 45 || f === 46 || f === 95 || f === 126 || f >= 48 && f <= 57 || f >= 65 && f <= 90 || f >= 97 && f <= 122 || i === wa.RFC1738 && (f === 40 || f === 41)) {
      s += o.charAt(c);
      continue;
    }
    if (f < 128) {
      s = s + J[f];
      continue;
    }
    if (f < 2048) {
      s = s + (J[192 | f >> 6] + J[128 | f & 63]);
      continue;
    }
    if (f < 55296 || f >= 57344) {
      s = s + (J[224 | f >> 12] + J[128 | f >> 6 & 63] + J[128 | f & 63]);
      continue;
    }
    c += 1, f = 65536 + ((f & 1023) << 10 | o.charCodeAt(c) & 1023), s += J[240 | f >> 18] + J[128 | f >> 12 & 63] + J[128 | f >> 6 & 63] + J[128 | f & 63];
  }
  return s;
}, Ta = function(t) {
  for (var r = [{ obj: { o: t }, prop: "o" }], n = [], a = 0; a < r.length; ++a)
    for (var i = r[a], o = i.obj[i.prop], s = Object.keys(o), c = 0; c < s.length; ++c) {
      var f = s[c], d = o[f];
      typeof d == "object" && d !== null && n.indexOf(d) === -1 && (r.push({ obj: o, prop: f }), n.push(d));
    }
  return $a(r), t;
}, xa = function(t) {
  return Object.prototype.toString.call(t) === "[object RegExp]";
}, Fa = function(t) {
  return !t || typeof t != "object" ? !1 : !!(t.constructor && t.constructor.isBuffer && t.constructor.isBuffer(t));
}, Ma = function(t, r) {
  return [].concat(t, r);
}, Ia = function(t, r) {
  if (se(t)) {
    for (var n = [], a = 0; a < t.length; a += 1)
      n.push(r(t[a]));
    return n;
  }
  return r(t);
}, Fr = {
  arrayToObject: xr,
  assign: Oa,
  combine: Ma,
  compact: Ta,
  decode: Aa,
  encode: Ea,
  isBuffer: Fa,
  isRegExp: xa,
  maybeMap: Ia,
  merge: ba
}, Mr = ga, ze = Fr, Ce = Ct, Ca = Object.prototype.hasOwnProperty, er = {
  brackets: function(t) {
    return t + "[]";
  },
  comma: "comma",
  indices: function(t, r) {
    return t + "[" + r + "]";
  },
  repeat: function(t) {
    return t;
  }
}, ee = Array.isArray, Da = Array.prototype.push, Ir = function(e, t) {
  Da.apply(e, ee(t) ? t : [t]);
}, Pa = Date.prototype.toISOString, tr = Ce.default, W = {
  addQueryPrefix: !1,
  allowDots: !1,
  charset: "utf-8",
  charsetSentinel: !1,
  delimiter: "&",
  encode: !0,
  encoder: ze.encode,
  encodeValuesOnly: !1,
  format: tr,
  formatter: Ce.formatters[tr],
  // deprecated
  indices: !1,
  serializeDate: function(t) {
    return Pa.call(t);
  },
  skipNulls: !1,
  strictNullHandling: !1
}, Ra = function(t) {
  return typeof t == "string" || typeof t == "number" || typeof t == "boolean" || typeof t == "symbol" || typeof t == "bigint";
}, ft = {}, Na = function e(t, r, n, a, i, o, s, c, f, d, p, w, A, F, N, z) {
  for (var D = t, u = z, l = 0, h = !1; (u = u.get(ft)) !== void 0 && !h; ) {
    var y = u.get(t);
    if (l += 1, typeof y < "u") {
      if (y === l)
        throw new RangeError("Cyclic object value");
      h = !0;
    }
    typeof u.get(ft) > "u" && (l = 0);
  }
  if (typeof c == "function" ? D = c(r, D) : D instanceof Date ? D = p(D) : n === "comma" && ee(D) && (D = ze.maybeMap(D, function(O) {
    return O instanceof Date ? p(O) : O;
  })), D === null) {
    if (i)
      return s && !F ? s(r, W.encoder, N, "key", w) : r;
    D = "";
  }
  if (Ra(D) || ze.isBuffer(D)) {
    if (s) {
      var m = F ? r : s(r, W.encoder, N, "key", w);
      return [A(m) + "=" + A(s(D, W.encoder, N, "value", w))];
    }
    return [A(r) + "=" + A(String(D))];
  }
  var M = [];
  if (typeof D > "u")
    return M;
  var $;
  if (n === "comma" && ee(D))
    F && s && (D = ze.maybeMap(D, s)), $ = [{ value: D.length > 0 ? D.join(",") || null : void 0 }];
  else if (ee(c))
    $ = c;
  else {
    var x = Object.keys(D);
    $ = f ? x.sort(f) : x;
  }
  for (var I = a && ee(D) && D.length === 1 ? r + "[]" : r, Q = 0; Q < $.length; ++Q) {
    var k = $[Q], b = typeof k == "object" && typeof k.value < "u" ? k.value : D[k];
    if (!(o && b === null)) {
      var v = ee(D) ? typeof n == "function" ? n(I, k) : I : I + (d ? "." + k : "[" + k + "]");
      z.set(t, l);
      var g = Mr();
      g.set(ft, z), Ir(M, e(
        b,
        v,
        n,
        a,
        i,
        o,
        n === "comma" && F && ee(D) ? null : s,
        c,
        f,
        d,
        p,
        w,
        A,
        F,
        N,
        g
      ));
    }
  }
  return M;
}, La = function(t) {
  if (!t)
    return W;
  if (t.encoder !== null && typeof t.encoder < "u" && typeof t.encoder != "function")
    throw new TypeError("Encoder has to be a function.");
  var r = t.charset || W.charset;
  if (typeof t.charset < "u" && t.charset !== "utf-8" && t.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var n = Ce.default;
  if (typeof t.format < "u") {
    if (!Ca.call(Ce.formatters, t.format))
      throw new TypeError("Unknown format option provided.");
    n = t.format;
  }
  var a = Ce.formatters[n], i = W.filter;
  return (typeof t.filter == "function" || ee(t.filter)) && (i = t.filter), {
    addQueryPrefix: typeof t.addQueryPrefix == "boolean" ? t.addQueryPrefix : W.addQueryPrefix,
    allowDots: typeof t.allowDots > "u" ? W.allowDots : !!t.allowDots,
    charset: r,
    charsetSentinel: typeof t.charsetSentinel == "boolean" ? t.charsetSentinel : W.charsetSentinel,
    delimiter: typeof t.delimiter > "u" ? W.delimiter : t.delimiter,
    encode: typeof t.encode == "boolean" ? t.encode : W.encode,
    encoder: typeof t.encoder == "function" ? t.encoder : W.encoder,
    encodeValuesOnly: typeof t.encodeValuesOnly == "boolean" ? t.encodeValuesOnly : W.encodeValuesOnly,
    filter: i,
    format: n,
    formatter: a,
    serializeDate: typeof t.serializeDate == "function" ? t.serializeDate : W.serializeDate,
    skipNulls: typeof t.skipNulls == "boolean" ? t.skipNulls : W.skipNulls,
    sort: typeof t.sort == "function" ? t.sort : null,
    strictNullHandling: typeof t.strictNullHandling == "boolean" ? t.strictNullHandling : W.strictNullHandling
  };
}, _a = function(e, t) {
  var r = e, n = La(t), a, i;
  typeof n.filter == "function" ? (i = n.filter, r = i("", r)) : ee(n.filter) && (i = n.filter, a = i);
  var o = [];
  if (typeof r != "object" || r === null)
    return "";
  var s;
  t && t.arrayFormat in er ? s = t.arrayFormat : t && "indices" in t ? s = t.indices ? "indices" : "repeat" : s = "indices";
  var c = er[s];
  if (t && "commaRoundTrip" in t && typeof t.commaRoundTrip != "boolean")
    throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
  var f = c === "comma" && t && t.commaRoundTrip;
  a || (a = Object.keys(r)), n.sort && a.sort(n.sort);
  for (var d = Mr(), p = 0; p < a.length; ++p) {
    var w = a[p];
    n.skipNulls && r[w] === null || Ir(o, Na(
      r[w],
      w,
      c,
      f,
      n.strictNullHandling,
      n.skipNulls,
      n.encode ? n.encoder : null,
      n.filter,
      n.sort,
      n.allowDots,
      n.serializeDate,
      n.format,
      n.formatter,
      n.encodeValuesOnly,
      n.charset,
      d
    ));
  }
  var A = o.join(n.delimiter), F = n.addQueryPrefix === !0 ? "?" : "";
  return n.charsetSentinel && (n.charset === "iso-8859-1" ? F += "utf8=%26%2310003%3B&" : F += "utf8=%E2%9C%93&"), A.length > 0 ? F + A : "";
}, $e = Fr, bt = Object.prototype.hasOwnProperty, Ba = Array.isArray, B = {
  allowDots: !1,
  allowPrototypes: !1,
  allowSparse: !1,
  arrayLimit: 20,
  charset: "utf-8",
  charsetSentinel: !1,
  comma: !1,
  decoder: $e.decode,
  delimiter: "&",
  depth: 5,
  ignoreQueryPrefix: !1,
  interpretNumericEntities: !1,
  parameterLimit: 1e3,
  parseArrays: !0,
  plainObjects: !1,
  strictNullHandling: !1
}, Ua = function(e) {
  return e.replace(/&#(\d+);/g, function(t, r) {
    return String.fromCharCode(parseInt(r, 10));
  });
}, Cr = function(e, t) {
  return e && typeof e == "string" && t.comma && e.indexOf(",") > -1 ? e.split(",") : e;
}, Wa = "utf8=%26%2310003%3B", ja = "utf8=%E2%9C%93", za = function(t, r) {
  var n = {}, a = r.ignoreQueryPrefix ? t.replace(/^\?/, "") : t, i = r.parameterLimit === 1 / 0 ? void 0 : r.parameterLimit, o = a.split(r.delimiter, i), s = -1, c, f = r.charset;
  if (r.charsetSentinel)
    for (c = 0; c < o.length; ++c)
      o[c].indexOf("utf8=") === 0 && (o[c] === ja ? f = "utf-8" : o[c] === Wa && (f = "iso-8859-1"), s = c, c = o.length);
  for (c = 0; c < o.length; ++c)
    if (c !== s) {
      var d = o[c], p = d.indexOf("]="), w = p === -1 ? d.indexOf("=") : p + 1, A, F;
      w === -1 ? (A = r.decoder(d, B.decoder, f, "key"), F = r.strictNullHandling ? null : "") : (A = r.decoder(d.slice(0, w), B.decoder, f, "key"), F = $e.maybeMap(
        Cr(d.slice(w + 1), r),
        function(N) {
          return r.decoder(N, B.decoder, f, "value");
        }
      )), F && r.interpretNumericEntities && f === "iso-8859-1" && (F = Ua(F)), d.indexOf("[]=") > -1 && (F = Ba(F) ? [F] : F), bt.call(n, A) ? n[A] = $e.combine(n[A], F) : n[A] = F;
    }
  return n;
}, ka = function(e, t, r, n) {
  for (var a = n ? t : Cr(t, r), i = e.length - 1; i >= 0; --i) {
    var o, s = e[i];
    if (s === "[]" && r.parseArrays)
      o = [].concat(a);
    else {
      o = r.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
      var c = s.charAt(0) === "[" && s.charAt(s.length - 1) === "]" ? s.slice(1, -1) : s, f = parseInt(c, 10);
      !r.parseArrays && c === "" ? o = { 0: a } : !isNaN(f) && s !== c && String(f) === c && f >= 0 && r.parseArrays && f <= r.arrayLimit ? (o = [], o[f] = a) : c !== "__proto__" && (o[c] = a);
    }
    a = o;
  }
  return a;
}, Ha = function(t, r, n, a) {
  if (t) {
    var i = n.allowDots ? t.replace(/\.([^.[]+)/g, "[$1]") : t, o = /(\[[^[\]]*])/, s = /(\[[^[\]]*])/g, c = n.depth > 0 && o.exec(i), f = c ? i.slice(0, c.index) : i, d = [];
    if (f) {
      if (!n.plainObjects && bt.call(Object.prototype, f) && !n.allowPrototypes)
        return;
      d.push(f);
    }
    for (var p = 0; n.depth > 0 && (c = s.exec(i)) !== null && p < n.depth; ) {
      if (p += 1, !n.plainObjects && bt.call(Object.prototype, c[1].slice(1, -1)) && !n.allowPrototypes)
        return;
      d.push(c[1]);
    }
    return c && d.push("[" + i.slice(c.index) + "]"), ka(d, r, n, a);
  }
}, qa = function(t) {
  if (!t)
    return B;
  if (t.decoder !== null && t.decoder !== void 0 && typeof t.decoder != "function")
    throw new TypeError("Decoder has to be a function.");
  if (typeof t.charset < "u" && t.charset !== "utf-8" && t.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var r = typeof t.charset > "u" ? B.charset : t.charset;
  return {
    allowDots: typeof t.allowDots > "u" ? B.allowDots : !!t.allowDots,
    allowPrototypes: typeof t.allowPrototypes == "boolean" ? t.allowPrototypes : B.allowPrototypes,
    allowSparse: typeof t.allowSparse == "boolean" ? t.allowSparse : B.allowSparse,
    arrayLimit: typeof t.arrayLimit == "number" ? t.arrayLimit : B.arrayLimit,
    charset: r,
    charsetSentinel: typeof t.charsetSentinel == "boolean" ? t.charsetSentinel : B.charsetSentinel,
    comma: typeof t.comma == "boolean" ? t.comma : B.comma,
    decoder: typeof t.decoder == "function" ? t.decoder : B.decoder,
    delimiter: typeof t.delimiter == "string" || $e.isRegExp(t.delimiter) ? t.delimiter : B.delimiter,
    // eslint-disable-next-line no-implicit-coercion, no-extra-parens
    depth: typeof t.depth == "number" || t.depth === !1 ? +t.depth : B.depth,
    ignoreQueryPrefix: t.ignoreQueryPrefix === !0,
    interpretNumericEntities: typeof t.interpretNumericEntities == "boolean" ? t.interpretNumericEntities : B.interpretNumericEntities,
    parameterLimit: typeof t.parameterLimit == "number" ? t.parameterLimit : B.parameterLimit,
    parseArrays: t.parseArrays !== !1,
    plainObjects: typeof t.plainObjects == "boolean" ? t.plainObjects : B.plainObjects,
    strictNullHandling: typeof t.strictNullHandling == "boolean" ? t.strictNullHandling : B.strictNullHandling
  };
}, Va = function(e, t) {
  var r = qa(t);
  if (e === "" || e === null || typeof e > "u")
    return r.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  for (var n = typeof e == "string" ? za(e, r) : e, a = r.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, i = Object.keys(n), o = 0; o < i.length; ++o) {
    var s = i[o], c = Ha(s, n[s], r, typeof e == "string");
    a = $e.merge(a, c, r);
  }
  return r.allowSparse === !0 ? a : $e.compact(a);
}, Qa = _a, Ja = Va, Ga = Ct, Ge = {
  formats: Ga,
  parse: Ja,
  stringify: Qa
};
const Ya = (e, { slugs: t, sortBy: r, pagination: n, highlighted: a, deepness: i = 3 }) => Ge.stringify({
  populate: `deep,${i}`,
  filters: {
    ...t && {
      slug: {
        $in: t
      }
    },
    ...a !== void 0 && {
      highlighted: {
        $eq: a
      }
    }
  },
  ...r && {
    sort: r
  },
  ...n && {
    pagination: {
      page: n.page,
      pageSize: n.pageSize
    }
  },
  locale: e
}, {
  encodeValuesOnly: !0
}), Ri = async (e, t, r, n, a) => {
  const i = Ya(e, n), o = await a(`${r}/${t}-articles?${i}`);
  if (!o.ok)
    throw new Ne("An error occurred while fetching articles", {
      status: o.status,
      url: o.url,
      originalError: o.statusText
    });
  return await o.json();
}, Za = (e, t, r, { sortBy: n, pagination: a, deepness: i = 3 }) => Ge.stringify({
  populate: `deep,${i}`,
  filters: {
    [`${t}_category`]: {
      slug: {
        $in: r
      }
    }
  },
  ...n && {
    sort: n
  },
  ...a && {
    pagination: {
      page: a.page,
      pageSize: a.pageSize
    }
  },
  locale: e
}, {
  encodeValuesOnly: !0
}), Ni = async (e, t, r, n, a, i) => {
  const o = Za(e, t, n, a), s = await i(`${r}/${t}-articles?${o}`);
  if (!s.ok)
    throw new Ne("An error occurred while fetching articles by category slug", {
      status: s.status,
      url: s.url,
      originalError: s.statusText
    });
  return await s.json();
}, Ka = (e, { slugs: t, sortBy: r, pagination: n, deepness: a = 2 }) => Ge.stringify({
  populate: `deep,${a}`,
  ...t && {
    filters: {
      slug: {
        $in: t
      }
    }
  },
  ...r && {
    sort: r
  },
  ...n && {
    pagination: {
      page: n.page,
      pageSize: n.pageSize
    }
  },
  locale: e
}, {
  encodeValuesOnly: !0
}), Li = async (e, t, r, n, a) => {
  const i = Ka(e, n), o = await a(`${r}/${t}-categories?${i}`);
  if (!o.ok)
    throw new Ne("An error occurred while fetching categories", {
      status: o.status,
      url: o.url,
      originalError: o.statusText
    });
  return await o.json();
}, Xa = (e, t) => Ge.stringify({
  populate: `deep,${t || 2}`,
  filters: {
    parent_categories: {
      id: {
        $null: !0
      }
    }
  },
  locale: e
}, {
  encodeValuesOnly: !0
}), _i = async (e, t, r, n, a) => {
  const i = Xa(e, a), o = await n(`${r}/${t}-categories?${i}`);
  if (!o.ok)
    throw new Ne("An error occurred while fetching parent categories", {
      status: o.status,
      url: o.url,
      originalError: o.statusText
    });
  return await o.json();
};
async function Bi(e, t, r, n, a) {
  if (!e)
    throw new Error("id is required");
  const i = await a(`${t}/media-cta/random/${r}/${e}`);
  if (!i.ok)
    throw new Ne("An error occurred while fetching native cta", {
      status: i.status,
      url: i.url,
      originalError: i.statusText
    });
  return await i.json();
}
class Ne extends Error {
  constructor(t, { status: r, url: n, originalError: a }) {
    super(t), this.status = r, this.url = n, this.originalError = a;
  }
}
function ei(e) {
  return [...e.matchAll(/<h2(.*?)>(.+?)<\/h2>/g)].filter((r) => !ri(r[0]));
}
function Ui(e, t, r) {
  let n;
  const a = [];
  return ei(e).forEach((o, s) => {
    n = o[0].replace("<h2", `<h2 id="${t}-${s}" `), a.push(n), e = e.replace(o[0], n);
  }), `${ti(a, r)}${e}`;
}
function ti(e, t) {
  let r = `<h2 class="cms-v3-article__summary__title">${t}&nbsp;:</h2><ul class="cms-v3-article__summary__menu">`, n = "", a = "";
  return e.forEach((i) => {
    a = [...i.match(/id="(.*?)"/) ?? []][1], n = i.replaceAll(`<h2 id="${a}"`, `<a rel="nofollow" href="#${a}"`).replaceAll(/style=(.*?);"/g, "").replaceAll("</h2>", "</a>").replaceAll(" ?", "&nbsp;?").replaceAll(" ,", "&nbsp;,").replaceAll(" .", "&nbsp;.").replaceAll(" :", "&nbsp;:").replaceAll(" ;", "&nbsp;;").replaceAll(" !", "&nbsp;!"), r = `${r}<li class="cms-v3-article__summary__item">${n}</li>`;
  }), `${r}</ul>`;
}
function ri(e) {
  return e.replace(/<(.+?)\/?>/gm, "").replaceAll(/&nbsp;/gm, "").replaceAll(/\s/gm, "").length === 0;
}
function Wi(e, t) {
  var n, a, i, o, s, c, f, d, p;
  const r = {
    headline: e.title,
    alternativeHeadline: (n = e.seo) == null ? void 0 : n.metaTitle,
    image: (a = e.image) == null ? void 0 : a.url,
    editor: `${(i = e.author) == null ? void 0 : i.firstname} ${(o = e.author) == null ? void 0 : o.lastname}`,
    keywords: ((s = e.seo) == null ? void 0 : s.keywords) || "",
    wordCount: e.content.split(" ").length,
    publisher: "WIZBII",
    url: t,
    datePublished: new Date(e.datePublished),
    dateCreated: new Date(e.dateCreated),
    dateModified: new Date(e.dateUpdated),
    description: e.summary,
    articleBody: e.content,
    ...(((c = e == null ? void 0 : e.author) == null ? void 0 : c.firstname) || ((f = e == null ? void 0 : e.author) == null ? void 0 : f.lastname)) && {
      author: {
        name: `${(d = e.author) == null ? void 0 : d.firstname} ${(p = e.author) == null ? void 0 : p.lastname}`
      }
    }
  };
  return `<script type="application/ld+json">${JSON.stringify(tn(r))}<\/script>`;
}
const rr = {
  dev: !0,
  debug: !0,
  browser: !0
};
var ae, De, Dr, Qe, Ot, Oe = function() {
  return window.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
}, Pe = function(e) {
  if (document.readyState === "loading")
    return "loading";
  var t = Oe();
  if (t) {
    if (e < t.domInteractive)
      return "loading";
    if (t.domContentLoadedEventStart === 0 || e < t.domContentLoadedEventStart)
      return "dom-interactive";
    if (t.domComplete === 0 || e < t.domComplete)
      return "dom-content-loaded";
  }
  return "complete";
}, ni = function(e) {
  var t = e.nodeName;
  return e.nodeType === 1 ? t.toLowerCase() : t.toUpperCase().replace(/^#/, "");
}, Ye = function(e, t) {
  var r = "";
  try {
    for (; e && e.nodeType !== 9; ) {
      var n = e, a = n.id ? "#" + n.id : ni(n) + (n.className && n.className.trim().length ? "." + n.className.trim().replace(/\s+/g, ".") : "");
      if (r.length + a.length > (t || 100) - 1)
        return r || a;
      if (r = r ? a + ">" + r : a, n.id)
        break;
      e = n.parentNode;
    }
  } catch {
  }
  return r;
}, Pr = -1, Rr = function() {
  return Pr;
}, le = function(e) {
  addEventListener("pageshow", function(t) {
    t.persisted && (Pr = t.timeStamp, e(t));
  }, !0);
}, Ze = function() {
  var e = Oe();
  return e && e.activationStart || 0;
}, q = function(e, t) {
  var r = Oe(), n = "navigate";
  return Rr() >= 0 ? n = "back-forward-cache" : r && (n = document.prerendering || Ze() > 0 ? "prerender" : document.wasDiscarded ? "restore" : r.type.replace(/_/g, "-")), { name: e, value: t === void 0 ? -1 : t, rating: "good", delta: 0, entries: [], id: "v3-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12), navigationType: n };
}, Ae = function(e, t, r) {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(e)) {
      var n = new PerformanceObserver(function(a) {
        Promise.resolve().then(function() {
          t(a.getEntries());
        });
      });
      return n.observe(Object.assign({ type: e, buffered: !0 }, r || {})), n;
    }
  } catch {
  }
}, V = function(e, t, r, n) {
  var a, i;
  return function(o) {
    t.value >= 0 && (o || n) && ((i = t.value - (a || 0)) || a === void 0) && (a = t.value, t.delta = i, t.rating = function(s, c) {
      return s > c[1] ? "poor" : s > c[0] ? "needs-improvement" : "good";
    }(t.value, r), e(t));
  };
}, Dt = function(e) {
  requestAnimationFrame(function() {
    return requestAnimationFrame(function() {
      return e();
    });
  });
}, Ke = function(e) {
  var t = function(r) {
    r.type !== "pagehide" && document.visibilityState !== "hidden" || e(r);
  };
  addEventListener("visibilitychange", t, !0), addEventListener("pagehide", t, !0);
}, Pt = function(e) {
  var t = !1;
  return function(r) {
    t || (e(r), t = !0);
  };
}, ge = -1, nr = function() {
  return document.visibilityState !== "hidden" || document.prerendering ? 1 / 0 : 0;
}, Je = function(e) {
  document.visibilityState === "hidden" && ge > -1 && (ge = e.type === "visibilitychange" ? e.timeStamp : 0, ai());
}, ar = function() {
  addEventListener("visibilitychange", Je, !0), addEventListener("prerenderingchange", Je, !0);
}, ai = function() {
  removeEventListener("visibilitychange", Je, !0), removeEventListener("prerenderingchange", Je, !0);
}, Rt = function() {
  return ge < 0 && (ge = nr(), ar(), le(function() {
    setTimeout(function() {
      ge = nr(), ar();
    }, 0);
  })), { get firstHiddenTime() {
    return ge;
  } };
}, Le = function(e) {
  document.prerendering ? addEventListener("prerenderingchange", function() {
    return e();
  }, !0) : e();
}, ir = [1800, 3e3], Nr = function(e, t) {
  t = t || {}, Le(function() {
    var r, n = Rt(), a = q("FCP"), i = Ae("paint", function(o) {
      o.forEach(function(s) {
        s.name === "first-contentful-paint" && (i.disconnect(), s.startTime < n.firstHiddenTime && (a.value = Math.max(s.startTime - Ze(), 0), a.entries.push(s), r(!0)));
      });
    });
    i && (r = V(e, a, ir, t.reportAllChanges), le(function(o) {
      a = q("FCP"), r = V(e, a, ir, t.reportAllChanges), Dt(function() {
        a.value = performance.now() - o.timeStamp, r(!0);
      });
    }));
  });
}, or = [0.1, 0.25], ii = function(e, t) {
  (function(r, n) {
    n = n || {}, Nr(Pt(function() {
      var a, i = q("CLS", 0), o = 0, s = [], c = function(d) {
        d.forEach(function(p) {
          if (!p.hadRecentInput) {
            var w = s[0], A = s[s.length - 1];
            o && p.startTime - A.startTime < 1e3 && p.startTime - w.startTime < 5e3 ? (o += p.value, s.push(p)) : (o = p.value, s = [p]);
          }
        }), o > i.value && (i.value = o, i.entries = s, a());
      }, f = Ae("layout-shift", c);
      f && (a = V(r, i, or, n.reportAllChanges), Ke(function() {
        c(f.takeRecords()), a(!0);
      }), le(function() {
        o = 0, i = q("CLS", 0), a = V(r, i, or, n.reportAllChanges), Dt(function() {
          return a();
        });
      }), setTimeout(a, 0));
    }));
  })(function(r) {
    (function(n) {
      if (n.entries.length) {
        var a = n.entries.reduce(function(s, c) {
          return s && s.value > c.value ? s : c;
        });
        if (a && a.sources && a.sources.length) {
          var i = (o = a.sources).find(function(s) {
            return s.node && s.node.nodeType === 1;
          }) || o[0];
          if (i)
            return void (n.attribution = { largestShiftTarget: Ye(i.node), largestShiftTime: a.startTime, largestShiftValue: a.value, largestShiftSource: i, largestShiftEntry: a, loadState: Pe(a.startTime) });
        }
      }
      var o;
      n.attribution = {};
    })(r), e(r);
  }, t);
}, oi = function(e, t) {
  Nr(function(r) {
    (function(n) {
      if (n.entries.length) {
        var a = Oe(), i = n.entries[n.entries.length - 1];
        if (a) {
          var o = a.activationStart || 0, s = Math.max(0, a.responseStart - o);
          return void (n.attribution = { timeToFirstByte: s, firstByteToFCP: n.value - s, loadState: Pe(n.entries[0].startTime), navigationEntry: a, fcpEntry: i });
        }
      }
      n.attribution = { timeToFirstByte: 0, firstByteToFCP: n.value, loadState: Pe(Rr()) };
    })(r), e(r);
  }, t);
}, Fe = { passive: !0, capture: !0 }, si = /* @__PURE__ */ new Date(), sr = function(e, t) {
  ae || (ae = t, De = e, Dr = /* @__PURE__ */ new Date(), _r(removeEventListener), Lr());
}, Lr = function() {
  if (De >= 0 && De < Dr - si) {
    var e = { entryType: "first-input", name: ae.type, target: ae.target, cancelable: ae.cancelable, startTime: ae.timeStamp, processingStart: ae.timeStamp + De };
    Qe.forEach(function(t) {
      t(e);
    }), Qe = [];
  }
}, ci = function(e) {
  if (e.cancelable) {
    var t = (e.timeStamp > 1e12 ? /* @__PURE__ */ new Date() : performance.now()) - e.timeStamp;
    e.type == "pointerdown" ? function(r, n) {
      var a = function() {
        sr(r, n), o();
      }, i = function() {
        o();
      }, o = function() {
        removeEventListener("pointerup", a, Fe), removeEventListener("pointercancel", i, Fe);
      };
      addEventListener("pointerup", a, Fe), addEventListener("pointercancel", i, Fe);
    }(t, e) : sr(t, e);
  }
}, _r = function(e) {
  ["mousedown", "keydown", "touchstart", "pointerdown"].forEach(function(t) {
    return e(t, ci, Fe);
  });
}, cr = [100, 300], ui = function(e, t) {
  t = t || {}, Le(function() {
    var r, n = Rt(), a = q("FID"), i = function(c) {
      c.startTime < n.firstHiddenTime && (a.value = c.processingStart - c.startTime, a.entries.push(c), r(!0));
    }, o = function(c) {
      c.forEach(i);
    }, s = Ae("first-input", o);
    r = V(e, a, cr, t.reportAllChanges), s && Ke(Pt(function() {
      o(s.takeRecords()), s.disconnect();
    })), s && le(function() {
      var c;
      a = q("FID"), r = V(e, a, cr, t.reportAllChanges), Qe = [], De = -1, ae = null, _r(addEventListener), c = i, Qe.push(c), Lr();
    });
  });
}, fi = function(e, t) {
  ui(function(r) {
    (function(n) {
      var a = n.entries[0];
      n.attribution = { eventTarget: Ye(a.target), eventType: a.name, eventTime: a.startTime, eventEntry: a, loadState: Pe(a.startTime) };
    })(r), e(r);
  }, t);
}, Br = 0, lt = 1 / 0, je = 0, li = function(e) {
  e.forEach(function(t) {
    t.interactionId && (lt = Math.min(lt, t.interactionId), je = Math.max(je, t.interactionId), Br = je ? (je - lt) / 7 + 1 : 0);
  });
}, Ur = function() {
  return Ot ? Br : performance.interactionCount || 0;
}, di = function() {
  "interactionCount" in performance || Ot || (Ot = Ae("event", li, { type: "event", buffered: !0, durationThreshold: 0 }));
}, ur = [200, 500], Wr = 0, fr = function() {
  return Ur() - Wr;
}, Z = [], dt = {}, lr = function(e) {
  var t = Z[Z.length - 1], r = dt[e.interactionId];
  if (r || Z.length < 10 || e.duration > t.latency) {
    if (r)
      r.entries.push(e), r.latency = Math.max(r.latency, e.duration);
    else {
      var n = { id: e.interactionId, latency: e.duration, entries: [e] };
      dt[n.id] = n, Z.push(n);
    }
    Z.sort(function(a, i) {
      return i.latency - a.latency;
    }), Z.splice(10).forEach(function(a) {
      delete dt[a.id];
    });
  }
}, pi = function(e, t) {
  t = t || {}, Le(function() {
    di();
    var r, n = q("INP"), a = function(o) {
      o.forEach(function(f) {
        f.interactionId && lr(f), f.entryType === "first-input" && !Z.some(function(d) {
          return d.entries.some(function(p) {
            return f.duration === p.duration && f.startTime === p.startTime;
          });
        }) && lr(f);
      });
      var s, c = (s = Math.min(Z.length - 1, Math.floor(fr() / 50)), Z[s]);
      c && c.latency !== n.value && (n.value = c.latency, n.entries = c.entries, r());
    }, i = Ae("event", a, { durationThreshold: t.durationThreshold || 40 });
    r = V(e, n, ur, t.reportAllChanges), i && (i.observe({ type: "first-input", buffered: !0 }), Ke(function() {
      a(i.takeRecords()), n.value < 0 && fr() > 0 && (n.value = 0, n.entries = []), r(!0);
    }), le(function() {
      Z = [], Wr = Ur(), n = q("INP"), r = V(e, n, ur, t.reportAllChanges);
    }));
  });
}, yi = function(e, t) {
  pi(function(r) {
    (function(n) {
      if (n.entries.length) {
        var a = n.entries.sort(function(i, o) {
          return o.duration - i.duration || o.processingEnd - o.processingStart - (i.processingEnd - i.processingStart);
        })[0];
        n.attribution = { eventTarget: Ye(a.target), eventType: a.name, eventTime: a.startTime, eventEntry: a, loadState: Pe(a.startTime) };
      } else
        n.attribution = {};
    })(r), e(r);
  }, t);
}, dr = [2500, 4e3], pt = {}, hi = function(e, t) {
  (function(r, n) {
    n = n || {}, Le(function() {
      var a, i = Rt(), o = q("LCP"), s = function(d) {
        var p = d[d.length - 1];
        p && p.startTime < i.firstHiddenTime && (o.value = Math.max(p.startTime - Ze(), 0), o.entries = [p], a());
      }, c = Ae("largest-contentful-paint", s);
      if (c) {
        a = V(r, o, dr, n.reportAllChanges);
        var f = Pt(function() {
          pt[o.id] || (s(c.takeRecords()), c.disconnect(), pt[o.id] = !0, a(!0));
        });
        ["keydown", "click"].forEach(function(d) {
          addEventListener(d, f, !0);
        }), Ke(f), le(function(d) {
          o = q("LCP"), a = V(r, o, dr, n.reportAllChanges), Dt(function() {
            o.value = performance.now() - d.timeStamp, pt[o.id] = !0, a(!0);
          });
        });
      }
    });
  })(function(r) {
    (function(n) {
      if (n.entries.length) {
        var a = Oe();
        if (a) {
          var i = a.activationStart || 0, o = n.entries[n.entries.length - 1], s = o.url && performance.getEntriesByType("resource").filter(function(A) {
            return A.name === o.url;
          })[0], c = Math.max(0, a.responseStart - i), f = Math.max(c, s ? (s.requestStart || s.startTime) - i : 0), d = Math.max(f, s ? s.responseEnd - i : 0), p = Math.max(d, o ? o.startTime - i : 0), w = { element: Ye(o.element), timeToFirstByte: c, resourceLoadDelay: f - c, resourceLoadTime: d - f, elementRenderDelay: p - d, navigationEntry: a, lcpEntry: o };
          return o.url && (w.url = o.url), s && (w.lcpResourceEntry = s), void (n.attribution = w);
        }
      }
      n.attribution = { timeToFirstByte: 0, resourceLoadDelay: 0, resourceLoadTime: 0, elementRenderDelay: n.value };
    })(r), e(r);
  }, t);
}, pr = [800, 1800], mi = function e(t) {
  document.prerendering ? Le(function() {
    return e(t);
  }) : document.readyState !== "complete" ? addEventListener("load", function() {
    return e(t);
  }, !0) : setTimeout(t, 0);
}, gi = function(e, t) {
  t = t || {};
  var r = q("TTFB"), n = V(e, r, pr, t.reportAllChanges);
  mi(function() {
    var a = Oe();
    if (a) {
      var i = a.responseStart;
      if (i <= 0 || i > performance.now())
        return;
      r.value = Math.max(i - Ze(), 0), r.entries = [a], n(!0), le(function() {
        r = q("TTFB", 0), (n = V(e, r, pr, t.reportAllChanges))(!0);
      });
    }
  });
}, vi = function(e, t) {
  gi(function(r) {
    (function(n) {
      if (n.entries.length) {
        var a = n.entries[0], i = a.activationStart || 0, o = Math.max(a.domainLookupStart - i, 0), s = Math.max(a.connectStart - i, 0), c = Math.max(a.requestStart - i, 0);
        n.attribution = { waitingTime: o, dnsTime: s - o, connectionTime: c - s, requestTime: n.value - c, navigationEntry: a };
      } else
        n.attribution = { waitingTime: 0, dnsTime: 0, connectionTime: 0, requestTime: 0 };
    })(r), e(r);
  }, t);
};
const jr = "[Web Vitals Analytics]", Si = () => "connection" in window.navigator && window.navigator.connection && "effectiveType" in window.navigator.connection ? window.navigator.connection.effectiveType : void 0, yr = (e) => e.split("?")[0], wi = ({ params: e, path: t }) => Object.entries(e).reduce((r, [n, a]) => r.replace(a, `[${n}]`), t), $i = (e, { applicationId: t, params: r, path: n }, a) => ({
  id: e.id,
  applicationId: t,
  page: yr(wi({ params: r, path: n })),
  href: yr(window.location.href),
  eventName: e.name,
  value: e.value.toString(),
  ...a ? { connectionSpeed: a } : {}
}), bi = (e) => new Blob([new URLSearchParams(e).toString()], {
  type: "application/x-www-form-urlencoded"
}), ye = async (e, { applicationId: t, envFqdn: r, params: n, path: a }, { debug: i, dev: o, browser: s }) => {
  const c = $i(e, { applicationId: t, params: n, path: a }, Si());
  if (o || !s || ["localhost", "127.0.0.1", "wizbii.me"].some((f) => window.location.href.includes(f))) {
    i && console.debug(jr, e.name, JSON.stringify(c, null, 2));
    return;
  }
  await Oi(c, r);
}, Oi = (e, t) => fetch(`https://www.${t}/_api/web-metrics-api`, {
  body: bi(e),
  method: "POST",
  credentials: "omit",
  keepalive: !0
}), ji = (e, t = rr) => {
  const r = { ...rr, ...t };
  try {
    fi(async (n) => await ye(n, e, r)), vi(async (n) => await ye(n, e, r)), hi(async (n) => await ye(n, e, r)), ii(async (n) => await ye(n, e, r)), oi(async (n) => await ye(n, e, r)), yi(async (n) => await ye(n, e, r));
  } catch (n) {
    console.error(jr, n);
  }
};
export {
  gr as Cookie,
  Nt as GravityEnum,
  Ai as ImaginaryService,
  me as OperationTypesEnum,
  rn as SPREADS,
  X as WebComponentEnum,
  ti as buildSummary,
  Xr as deserializeJwt,
  Bt as findLinksInGap,
  tn as generateBlogPostingSchemaJsonLD,
  Fi as generateEventSchemaJsonLD,
  Mi as generateFAQPageSchemaJsonLD,
  Ii as generateJobPostingSchemaJsonLD,
  Ci as generateNewsArticleSchemaJsonLD,
  Di as generateOrganizationSchemaJsonLD,
  Pi as generatePagination,
  _i as getAllParentsCategories,
  Ri as getArticles,
  Ni as getArticlesByCategorySlug,
  $i as getBody,
  Li as getCategories,
  xi as getJwtFromCookie,
  Bi as getNativeCta,
  wi as getPage,
  Ti as getRequestHeaderWithAuth,
  Wi as getSerializedSchema,
  Ui as insertSummaryIntoContent,
  yr as removeQueryParamsFromUrl,
  Ei as replaceInjectorByCdnPath,
  et as roundToNearest,
  Oi as sendFetchBeacon,
  ji as sendWebVitals,
  rr as webVitalsDefaultOptions
};
